import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { AppUser } from 'Src/views/App/App';
import './TournamentView.css';
import { TournamentCoverUploader } from './TournamentCoverUploader';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { DatePicker as SitDatePicker } from 'Src/components/DatePicker/DatePicker';
import { Loader } from 'Src/components/Loader/Loader';
import {
  createTournament,
  getTournament,
  getUpcomingTournamentsCount,
  updateTournament
} from 'Src/helpers/service/adminSU/tournamentsTable';
import { Tournament } from 'Src/models/tournament';
import {
  DEFAULT_EVENT_IMPORT_PROPERTIES,
  TOURNAMENT_PAYMENT_TYPE,
  TOURNAMENT_PRICE_TYPE,
  TOURNAMENT_SUBTYPE,
  TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING,
  TOURNAMENT_TYPE,
  TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING
} from 'Src/consts/tournament';
import { GENDER, MODE_TYPE, YES_NO_OPTIONS } from 'Src/consts/common';
import { Autocomplete } from 'Src/components/Autocomplete/Autocomplete';
import {
  getName,
  getNameByPlaceOrPostcode,
  searchFunctionPaymentAccounts,
  searchFunctionSportsWithFavorite,
  searchFunctionAdmins
} from 'Src/helpers/autocomplete/autocomplete';
import moment from 'moment';
import { AGE_GROUPS } from 'Src/consts/school';
import { CLUB_CURRENCY } from 'Src/consts/club';
import { CurrencyInput } from 'Src/components/CurrencyInput/CurrencyInput';
import { CURRENCY_TYPE } from 'Src/types/common';
import { TournamentCustomSectionForm } from './TournamentCustomSectionForm/TournamentCustomSectionForm';
import { uploadFile } from 'Src/helpers/service/file';
import { TournamentNationalGoverningBodiesForm } from './TournamentNationalGoverningBodiesForm/TournamentNationalGoverningBodiesForm';
import { Point } from 'Src/models/venue';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { createVenue, deleteVenue } from 'Src/helpers/service/admin/venues';
import { VenueForm } from 'Src/views/GenericView/AdminView/School/Venues/VenueForm/VenueForm';
import { HTML_FIRST_PART_PAGE_CODE, HTML_LAST_PART_PAGE_CODE } from 'Src/components/HTMLEditorQuill/HTMLEditorConst';
import { HTMLEditorQuillHide } from 'Src/components/HTMLEditorQuill/HTMLEditorQuillHide';
import { getBooleanForYesOrNo, getYesOrNoForBoolean } from 'Src/helpers/tournament/tournament';
import {
  convertPlaceToPostcodeWithPlaceName,
  getDefaultPoint,
  getDefaultTournamentPostcode,
  getHomeSchoolPostCode,
  getPostcodes,
  getVenueTypeByPostcode,
  isPlace
} from '../../../../../helpers/venue/venue';
import { FIRST_PAGE, LIMIT } from '../../../../../consts/table';
import { getPagesCount } from 'Src/helpers/table/table';
import { getTodayMidnight } from 'Src/helpers/common/common';
import { LabelWithQuestionIcon } from './../../../../../components/LabelWithQuestionIcon/LabelWithQuestionIcon';
import { Switch } from './../../../../../components/Switch/Switch';
import { createTournamentTag, getAllTournamentTags } from 'Src/helpers/service/adminSU/tournamentTags';
import { assignTournamentTag } from 'Src/helpers/service/adminSU/tournamentGrid';
import { TournamentTag } from 'Src/models/tournamentTag';
import { UnsavedChangesModal } from 'Src/components/UnsavedChangesModal/UnsavedChangesModal';
import { formatTournamentAges } from 'Src/helpers/ageGroups';

const TYPE_OF_TOURNAMENT_PAYMENT_TYPE_OPTIONS = [{ text: 'Fixed price', value: 'FIXED_PRICE' }];
const TYPE_OF_TOURNAMENT_PRICE_TYPE_OPTIONS = [
  { text: 'Free', value: 'FREE' },
  { text: 'Paid', value: 'PAID' }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  tournament?: Tournament;
  coverPhotoUrls: string[];
  isImageError: boolean;
  isLoading: boolean;
  announcements: any[];
  nationalGoverningBodies: any[];
  sponsors: any[];
  point: Point;
  venue: any;
  isDeleteVenueModalOpen: boolean;
  isCreateVenueFormOpen: boolean;

  isPaymentSettingsVisible: boolean;
  isAdvancedSettingsVisible: boolean;

  adminsTouched: boolean;
  adminsOptions: Array<{ id: string; name: string; email?: string }>;
  wizardStep: number;
  wizardMaxStep: number;
  tournamentTagOptions: TournamentTag[];
  selectedTournamentTagIds: string[];
  editingAnnouncementIndex?: number;
  editingGoverningBodyIndex?: number;
  editingSponsorIndex?: number;
  optionalEditorIsNew: boolean;
  isTagModalOpen: boolean;
  tagDraft: { tagName: string; tagDescription: string; tagColor: string; isPublic: boolean };
  previewAnnouncementIndex?: number;
  isCancelConfirmationOpen: boolean;
  auxiliaryDirty: boolean;
  isShowAllSports: boolean;
}

interface AdminItem {
  userId: string;
  permissionId: string;
  name?: string;
}

interface TournamentFormValues {
  name: string;
  description: string;
  ageGroups: any[];
  gender: string;
  startTime: any;
  endTime: any;
  isAgeGroupsOnWebSiteVisible: string; // YES/NO
  isMixedTeamsAvailable: string; // YES/NO
  isSchoolCanSubmitResult: string; // YES/NO
  resultPublishingMode: 'IMMEDIATE' | 'REVIEW';
  supportsHalfTime: boolean;
  supportsExtraTime: boolean;
  supportsShootout: boolean;
  supportsScorers: boolean;
  scorerTimePrecision: 'NONE' | 'MINUTE' | 'SECOND';
  defaultEventDurationMinutes: number;
  isShowTwitter: string; // YES/NO
  tournamentType: string;
  tournamentSubType: string;
  sport: any;
  sportId: string;
  scoring: string;
  useAdminsForNotifications: boolean;
  organisers: string;
  organisersEmail: string | null;

  admins: AdminItem[];

  priceType: string;
  isPaymentSettingsVisible: boolean;
  paymentType: string;
  price: number;
  paymentAccountId: number | undefined;
  paymentAccountCurrent?: { id: string; name: string } | undefined;

  isAdvancedSettingsVisible: boolean;
  entriesOpen: any;
  deadlineForEntries: any;
  isWhenSpacesAreFull: string; // YES/NO

  tournamentStreamIsEnabled: string; // YES/NO
  tournamentStreamUrl: string;

  resultImportPropertiesFieldsPlayerNumber: string;
  resultImportPropertiesFieldsTeamCode: string;
  resultImportPropertiesFieldsResult: string;
  resultImportPropertiesFieldsDelimiter: string;
  resultImportPropertiesResultMask: string;

  venue: any;
  maxPlayersPerTeam: number | '';
  isEventParticipantLimitEnforced: boolean;
  maxIndividualEventsPerStudent: number | '';
  maxRelayEventsPerStudent: number | '';
  halfScoreForNetball: boolean;
  positionsCountForTeamPoints: Record<string, number>;
}

const today = new Date();
today.setHours(0, 0, 0, 0);

const now = () => new Date();

const addHours = (d: Date, hours: number) => {
  const x = new Date(d);
  x.setTime(x.getTime() + hours * 60 * 60 * 1000);
  return x;
};

const calcDefaultDeadlineForEntries = (entriesOpen: Date, tournamentStart?: Date | null) => {
  let candidate: Date;

  if (tournamentStart && moment(tournamentStart).isValid()) {
    candidate = moment(tournamentStart)
      .subtract(14, 'days')
      .endOf('day')
      .toDate();
  } else {
    candidate = moment(entriesOpen)
      .add(14, 'days')
      .endOf('day')
      .toDate();
  }

  if (candidate.getTime() <= entriesOpen.getTime()) {
    candidate = moment(entriesOpen)
      .add(7, 'days')
      .endOf('day')
      .toDate();
  }

  const n = now();
  if (candidate.getTime() <= n.getTime()) {
    candidate = moment(n)
      .add(1, 'days')
      .endOf('day')
      .toDate();
  }

  return candidate;
};

const buildTournamentValidationSchema = (opts: {
  allowPastEntriesOpen: boolean;
  allowPastDeadlineForEntries: boolean;
}) =>
  Yup.object().shape({
    name: Yup.string().required('Required'),
    ageGroups: Yup.array()
      .of(Yup.number().typeError('Invalid age group'))
      .min(1, 'Select at least one age group')
      .test('ageGroup-check', 'Only one age group can be selected for this tournament type', function(value) {
        const { tournamentType } = this.parent;
        if (tournamentType !== TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT && Array.isArray(value) && value.length > 1) {
          return false;
        }
        return true;
      })
      .required('Required'),

    startTime: Yup.date().required('Required'),
    endTime: Yup.date()
      .required('Required')
      .when('startTime', ([startTime], schema) => {
        return startTime && startTime !== 'undefined'
          ? schema.min(startTime, 'End time must be after start time')
          : schema;
      }),

    sportId: Yup.string().required('Required'),

    defaultEventDurationMinutes: Yup.number()
      .typeError('Enter a duration in minutes')
      .integer('Enter a whole number of minutes')
      .min(1, 'Duration must be at least 1 minute')
      .max(1440, 'Duration cannot exceed 24 hours')
      .required('Required'),

    entriesOpen: Yup.date()
      .nullable()
      .notRequired()
      .test('entriesOpen-future-or-keep-old', 'Entries open must be in the future', function(value) {
        if (!value) return true;

        const ts = new Date(value as any).getTime();
        const n = Date.now();

        if (ts >= n) return true;
        return Boolean(opts.allowPastEntriesOpen);
      }),

    deadlineForEntries: Yup.date()
      .nullable()
      .notRequired()
      .test('deadlineForEntries-future-or-keep-old', 'Deadline for entries must be in the future', function(value) {
        if (!value) return true;

        const ts = new Date(value as any).getTime();
        const n = Date.now();

        if (ts >= n) return true;
        return Boolean(opts.allowPastDeadlineForEntries);
      })
      .when('entriesOpen', ([entriesOpen], schema) =>
        entriesOpen ? schema.min(entriesOpen, 'Deadline for entries must be after entries open') : schema
      ),

    scoring: Yup.string()
      .matches(/^\s*\d+(\s*,\s*\d+)*\s*$/, 'Enter whole numbers separated by commas')
      .test('team-scoring-count', 'Team tournament scoring requires exactly 4 values', function(value) {
        if (this.parent.tournamentType !== TOURNAMENT_TYPE.TEAM_TOURNAMENT) return true;
        return (
          String(value || '')
            .split(',')
            .map(item => item.trim())
            .filter(Boolean).length === 4
        );
      })
      .required('Required'),

    organisersEmail: Yup.string()
      .nullable()
      .transform(value => (typeof value === 'string' && value.trim() === '' ? null : value))
      .email('Enter a valid email address'),

    price: Yup.number().required('Required'),

    resultImportPropertiesFieldsPlayerNumber: Yup.string().required('Required'),
    resultImportPropertiesFieldsTeamCode: Yup.string().required('Required'),
    resultImportPropertiesFieldsResult: Yup.string().required('Required'),
    resultImportPropertiesFieldsDelimiter: Yup.string().required('Required'),

    maxPlayersPerTeam: Yup.number()
      .integer('Must be an integer')
      .min(0, 'Must be at least 0')
      .nullable(),
    maxIndividualEventsPerStudent: Yup.number()
      .integer('Must be an integer')
      .min(0, 'Must be at least 0')
      .nullable(),
    maxRelayEventsPerStudent: Yup.number()
      .integer('Must be an integer')
      .min(0, 'Must be at least 0')
      .nullable(),

    venue: Yup.mixed()
      .required('Venue is required')
      .test('venue-shape', 'Venue is required', (v: any) => isTournamentVenueSelected(v))
  });

function isTournamentVenueSelected(venue: any): boolean {
  return Boolean(
    venue &&
      [venue.id, venue.postcodeId, venue.placeId, propz.get(venue, ['postcodeData', 'id'])].some(
        value => value !== undefined && value !== null && String(value).trim() !== ''
      )
  );
}

const getAdminTitle = (u: any) => u?.name || [u?.firstName, u?.lastName].filter(Boolean).join(' ') || u?.id;
const TOURNAMENT_WIZARD_STEP_TITLES = [
  'Basics',
  'Schedule & venue',
  'Competition & contacts',
  'Appearance',
  'Custom sections',
  'Governing bodies',
  'Sponsors',
  'Review & options'
];

export class TournamentView extends Component<Props, State> {
  tournamentFormRef = React.createRef<any>();
  private unblockNavigation?: () => void;
  private pendingLocation?: any;
  private allowNavigation = false;

  constructor(props: Props) {
    super(props);

    const { user } = this.props;

    this.state = {
      tournament: undefined,
      isLoading: false,
      coverPhotoUrls: [],
      isImageError: false,
      announcements: [],
      nationalGoverningBodies: [],
      sponsors: [],
      point: getDefaultPoint(user),
      venue: undefined,

      isDeleteVenueModalOpen: false,
      isCreateVenueFormOpen: false,

      isPaymentSettingsVisible: false,
      isAdvancedSettingsVisible: false,
      adminsTouched: false,
      adminsOptions: [],
      wizardStep: 0,
      wizardMaxStep: this.getMode() === MODE_TYPE.EDIT ? TOURNAMENT_WIZARD_STEP_TITLES.length - 1 : 0,
      tournamentTagOptions: [],
      selectedTournamentTagIds: [],
      editingAnnouncementIndex: undefined,
      editingGoverningBodyIndex: undefined,
      optionalEditorIsNew: false,
      isTagModalOpen: false,
      tagDraft: { tagName: '', tagDescription: '', tagColor: '#227ebd', isPublic: false },
      previewAnnouncementIndex: undefined,
      isCancelConfirmationOpen: false,
      auxiliaryDirty: false,
      isShowAllSports: false
    };
  }

  componentDidMount() {
    this.unblockNavigation = this.props.history.block(location => {
      if (this.allowNavigation || !this.hasUnsavedChanges()) return undefined;
      this.pendingLocation = location;
      this.setState({ isCancelConfirmationOpen: true });
      return false;
    });
    window.addEventListener('beforeunload', this.onBeforeUnload);

    if (this.isTournamentExist()) {
      this.setState({
        isLoading: true
      });
      this.setAdditionalItems();
    }
    getAllTournamentTags(this.props.user)
      .then(tournamentTagOptions => this.setState({ tournamentTagOptions }))
      .catch(() => this.setState({ tournamentTagOptions: [] }));
    this.syncWizardHeader();
    window.setTimeout(this.syncWizardHeader, 0);
  }

  componentDidUpdate(_prevProps: Props, prevState: State) {
    if (prevState.wizardStep !== this.state.wizardStep) this.syncWizardHeader();
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
    if (this.unblockNavigation) this.unblockNavigation();
    if (this.isCreateWizardMode()) {
      window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
      window.dispatchEvent(new CustomEvent('sit:topbar-wizard-clear'));
    }
  }

  hasUnsavedChanges = () =>
    Boolean(this.state.auxiliaryDirty || propz.get(this.tournamentFormRef, ['current', 'dirty'], false));

  onBeforeUnload = (event: BeforeUnloadEvent) => {
    if (!this.hasUnsavedChanges()) return;
    event.preventDefault();
    event.returnValue = '';
  };

  keepEditing = () => {
    this.pendingLocation = undefined;
    this.setState({ isCancelConfirmationOpen: false });
  };

  discardChangesAndLeave = () => {
    const pendingLocation = this.pendingLocation;
    this.pendingLocation = undefined;
    this.allowNavigation = true;
    if (this.unblockNavigation) {
      this.unblockNavigation();
      this.unblockNavigation = undefined;
    }
    this.setState({ isCancelConfirmationOpen: false }, () => {
      if (pendingLocation) this.props.history.push(pendingLocation);
      else this.onCancelButtonClick();
    });
  };

  allowNextNavigation = () => {
    this.allowNavigation = true;
    if (this.unblockNavigation) {
      this.unblockNavigation();
      this.unblockNavigation = undefined;
    }
  };

  isCreateWizardMode = () => {
    const mode = this.getMode();
    return !this.isTournamentExist() || mode === MODE_TYPE.COPY || mode === MODE_TYPE.EDIT;
  };

  syncWizardHeader = () => {
    if (!this.isCreateWizardMode()) return;
    const mode = this.getMode();
    const action =
      mode === MODE_TYPE.COPY ? 'Copy tournament' : mode === MODE_TYPE.EDIT ? 'Edit tournament' : 'Create tournament';
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: `Tournaments / ${action}` }));
    window.dispatchEvent(
      new CustomEvent('sit:topbar-wizard', {
        detail: {
          steps: TOURNAMENT_WIZARD_STEP_TITLES.map((label, index) => ({
            label,
            state: index === this.state.wizardStep ? 'active' : index <= this.state.wizardMaxStep ? 'done' : 'pending'
          }))
        }
      })
    );
  };

  getTournamentId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const tournamentId = search.tournament;

    return tournamentId;
  }

  getMode(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const mode = propz.get(search, ['mode'], '');

    return mode;
  }

  setAdditionalItems() {
    const { user } = this.props;

    const tournamentId = this.getTournamentId();

    return getTournament(user, tournamentId).then(tournament => {
      this.setState({
        tournament: tournament,
        coverPhotoUrls: propz
          .get(tournament, ['photos'], [])
          .map(photo => String(propz.get(photo, ['picUrl'], '') || ''))
          .filter(Boolean),
        announcements: propz.get(tournament, ['announcements'], []),
        nationalGoverningBodies: propz.get(tournament, ['nationalGoverningBodies'], []),
        sponsors: propz.get(tournament, ['sponsors'], []),
        selectedTournamentTagIds: propz.get(tournament, ['tournamentTags'], []).map(tag => String(tag.id)),
        point:
          typeof tournament.venue !== 'undefined' &&
          propz.get(tournament, ['venue', 'point', 'coordinates'], []).length !== 0
            ? propz.get(tournament, ['venue', 'point'])
            : getDefaultPoint(user),
        venue: getDefaultTournamentPostcode(tournament, user.activeSchool),
        isLoading: false
      });
      return true;
    });
  }

  isTournamentExist(): boolean {
    const { history } = this.props;
    const search = parse(history.location.search);
    const tournamentId = search.tournament;

    return typeof tournamentId !== 'undefined';
  }

  getFullNameWithEmail = (u: any) => {
    const name = [u?.firstName, u?.lastName].filter(Boolean).join(' ') || u?.name || '';
    return u?.email ? `${name} — ${u.email}` : name || u?.id;
  };

  getAdminsSearchFunction = (text: string, selectedAdmins: Array<{ userId: string }> = []) => {
    const { user } = this.props;
    const activeSchoolId = user.activeSchoolId;
    return searchFunctionAdmins(user, text, activeSchoolId, selectedAdmins);
  };

  onSaveButtonClick = (dataCopy): void => {
    const { user, history } = this.props;
    const isTournamentExists = this.isTournamentExist();
    const tournamentId = this.getTournamentId();
    const mode = this.getMode();
    const assignSelectedTags = tournament =>
      Promise.all(
        this.state.selectedTournamentTagIds.map(tournamentTagId =>
          assignTournamentTag(user, { tournamentTagId }, tournament.id)
        )
      ).then(() => tournament);

    switch (true) {
      case isTournamentExists && mode === 'edit':
        updateTournament(user, dataCopy, tournamentId)
          .then(tournament => {
            this.allowNextNavigation();
            this.goBackEditTournament(tournament.id);
          })
          .catch(error => {
            console.error(error.response.data.details.text);
          });
        break;

      case isTournamentExists && mode === 'copy':
        createTournament(user, dataCopy)
          .then(assignSelectedTags)
          .then(tournament => {
            this.allowNextNavigation();
            this.goBackCreateTournament(tournament);
          })
          .catch(error => {
            console.error(error.response.data.details.text);
          });
        break;
      case !isTournamentExists:
        createTournament(user, dataCopy)
          .then(assignSelectedTags)
          .then(tournament => {
            this.allowNextNavigation();
            this.goBackCreateTournament(tournament);
          })
          .catch(error => {
            console.error(error.response.data.details.text);
          });
        break;
    }
  };

  onCancelButtonClick = (): void => {
    const tournamentId = this.getTournamentId();

    const { history, location } = this.props;
    const routeState = (location.state || {}) as any;
    const prevPath = routeState.prevPath || '/tournaments/upcoming';

    const filters = propz.get(routeState, ['filters']);
    const currentTournamentPage = propz.get(routeState, ['currentTournamentPage'], FIRST_PAGE);

    history.push({
      pathname: prevPath,
      search: `page=${currentTournamentPage}`,
      state: {
        tournamentId,
        filters
      }
    });
  };

  goBackCreateTournament = (tournament: Tournament): void => {
    const { history, user } = this.props;
    const openCreatedTournament = (page: number) => {
      history.push({
        pathname: '/tournaments/upcoming',
        search: `page=${Math.max(page, FIRST_PAGE)}`,
        state: { tournamentId: tournament.id }
      });
    };

    getUpcomingTournamentsCount(user, {
      startTime: {
        $gte: getTodayMidnight(),
        $lte: tournament.startTime
      }
    })
      .then(({ count }) => openCreatedTournament(getPagesCount(count, LIMIT)))
      .catch(() => openCreatedTournament(FIRST_PAGE));
  };

  goBackEditTournament = (tournamentId): void => {
    const { history, location } = this.props;
    const routeState = (location.state || {}) as any;
    const prevPath = routeState.prevPath || '/tournaments/upcoming';

    const currentTournamentPage = propz.get(routeState, ['currentTournamentPage'], FIRST_PAGE);
    const selectedFilters = propz.get(routeState, ['filters'], undefined);

    history.push({
      pathname: prevPath,
      search: `page=${currentTournamentPage}`,
      state: { tournamentId, filters: selectedFilters }
    });
  };

  getAgeGroup() {
    const user = this.props.user;
    const activeSchool = user.activeSchool;
    const ageGroupsNaming = activeSchool.ageGroupsNaming;
    const ageGroups = propz.get(AGE_GROUPS, [ageGroupsNaming]);
    return ageGroups.map((ageGroup, index) => {
      return {
        value: index,
        text: ageGroup
      };
    });
  }

  getSports = (text: string) => {
    const user = this.props.user;
    return searchFunctionSportsWithFavorite(user, text, !this.state.isShowAllSports);
  };

  getScoring(): string {
    const { tournament } = this.state;
    const isTournamentExists = this.isTournamentExist();
    if (isTournamentExists) {
      const scoringArray = propz.get(tournament, ['scoring'], []);
      return scoringArray.length > 0 ? scoringArray.map(scoring => scoring.score).join(', ') : '0';
    } else {
      return '0';
    }
  }

  togglePaymentSettingsVisibility = () => {
    this.setState(prevState => ({
      isPaymentSettingsVisible: !prevState.isPaymentSettingsVisible
    }));
  };

  toggleAdvancedSettingsVisibility = () => {
    this.setState(prevState => ({
      isAdvancedSettingsVisible: !prevState.isAdvancedSettingsVisible
    }));
  };

  getPaymentAccounts = () => {
    const user = this.props.user;

    return searchFunctionPaymentAccounts(user);
  };

  onSubmit = (values: TournamentFormValues) => {
    const { venue, coverPhotoUrls } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const startDate = values.startTime;
    const endDate = values.endTime;
    const startDateUTC = new Date(startDate);
    const finishDateUTC = new Date(endDate);
    const dataCopy = {
      name: values.name,
      description: values.description,
      sportId: values.sportId,
      startTime: new Date(values.startTime),
      endTime: new Date(values.endTime),
      ages: values.ageGroups.map(age => Number(age)),
      isAgeGroupsOnWebSiteVisible: getBooleanForYesOrNo(values.isAgeGroupsOnWebSiteVisible),
      type: values.tournamentType,
      subType: values.tournamentSubType,
      photos: coverPhotoUrls.map(picUrl => ({ picUrl })),
      gender: values.gender,
      isMixedTeamsAvailable: getBooleanForYesOrNo(values.isMixedTeamsAvailable),
      isSchoolCanSubmitResult: getBooleanForYesOrNo(values.isSchoolCanSubmitResult),
      resultPublishingMode: values.resultPublishingMode,
      resultCapabilities: {
        supportsHalfTime: values.supportsHalfTime,
        supportsExtraTime: values.supportsExtraTime,
        supportsShootout: values.supportsShootout,
        supportsScorers: values.supportsScorers,
        scorerTimePrecision: values.supportsScorers ? values.scorerTimePrecision : 'NONE'
      },
      eventDefaults: {
        durationMinutes: Number(values.defaultEventDurationMinutes) || 60
      },
      isShowTwitter: getBooleanForYesOrNo(values.isShowTwitter),
      organisers: values.organisers,
      organisersEmail: values.organisersEmail,
      scoring: [],
      price: {
        priceType: values.priceType,
        paymentType: values.paymentType,
        price: values.price
      },
      paymentSettings: {
        paymentAccountId: values.paymentAccountId
      },
      entriesOpen: values.entriesOpen ? new Date(values.entriesOpen) : null,
      deadlineForEntries: values.deadlineForEntries ? new Date(values.deadlineForEntries) : null,
      isWhenSpacesAreFull: getBooleanForYesOrNo(values.isWhenSpacesAreFull),
      tournamentStream: {
        isEnabled: getBooleanForYesOrNo(values.tournamentStreamIsEnabled),
        url: values.tournamentStreamUrl || ''
      },
      resultImportProperties: {
        fields: {
          playerNumber: values.resultImportPropertiesFieldsPlayerNumber,
          teamCode: values.resultImportPropertiesFieldsTeamCode,
          result: values.resultImportPropertiesFieldsResult,
          delimiter: values.resultImportPropertiesFieldsDelimiter
        },
        resultMask: values.resultImportPropertiesResultMask
      },
      announcements: this.state.announcements.map(announcement => {
        announcement.body = `${HTML_FIRST_PART_PAGE_CODE} ${announcement.body} ${HTML_LAST_PART_PAGE_CODE}`;
        return announcement;
      }),
      nationalGoverningBodies: this.state.nationalGoverningBodies,
      sponsors: this.state.sponsors,
      venue: venue,
      maxPlayersPerTeam: values.maxPlayersPerTeam !== '' ? values.maxPlayersPerTeam : 0,
      isEventParticipantLimitEnforced: values.isEventParticipantLimitEnforced,
      maxIndividualEventsPerStudent:
        values.maxIndividualEventsPerStudent !== '' ? values.maxIndividualEventsPerStudent : 0,
      maxRelayEventsPerStudent: values.maxRelayEventsPerStudent !== '' ? values.maxRelayEventsPerStudent : 0,
      positionsCountForTeamPoints: [],
      halfScoreForNetball: values.halfScoreForNetball,
      admins: [] as Array<{ userId: string }>,
      useAdminsForNotifications: values.useAdminsForNotifications
    };

    if (
      values.tournamentSubType === TOURNAMENT_SUBTYPE.CROSS_COUNTRY ||
      values.tournamentSubType === TOURNAMENT_SUBTYPE.NATIONAL_CROSS_COUNTRY
    ) {
      const positionsObj = values.positionsCountForTeamPoints || {};
      const positionsArray = Object.keys(positionsObj).map(key => {
        const [year, gender] = key.split('_');
        return { year: Number(year), gender, count: Number(positionsObj[key]) };
      });
      dataCopy.positionsCountForTeamPoints = positionsArray;
    }

    if (
      values.tournamentType === TOURNAMENT_TYPE.TEAM_TOURNAMENT &&
      values.tournamentSubType === TOURNAMENT_SUBTYPE.NETBALL
    ) {
      dataCopy.halfScoreForNetball = values.halfScoreForNetball;
    }

    if (!values.scoring || values.scoring.trim() === '') {
      dataCopy.scoring = ['0'];
    } else {
      const scoring = values.scoring.split(',').map(score => score.trim());
      if (Array.isArray(scoring) && scoring.length > 0) {
        dataCopy.scoring = scoring.map(score => {
          return { score: Number(score) };
        });
      }
    }

    if (values.entriesOpen) {
      dataCopy.entriesOpen = new Date(values.entriesOpen);
    } else {
      dataCopy.entriesOpen = null;
    }

    if (values.deadlineForEntries) {
      dataCopy.deadlineForEntries = new Date(values.deadlineForEntries);
    } else {
      dataCopy.deadlineForEntries = null;
    }

    if (values.organisersEmail && values.organisersEmail.trim() !== '') {
      dataCopy.organisersEmail = values.organisersEmail;
    } else {
      dataCopy.organisersEmail = null;
    }

    if (values.priceType === TOURNAMENT_PRICE_TYPE.FREE) {
      delete dataCopy.paymentSettings.paymentAccountId;
    }

    switch (true) {
      case typeof venue !== 'undefined' && typeof venue.point !== 'undefined' && venue.point.coordinates.length > 0:
        if (typeof venue.postcodeId === 'undefined') {
          dataCopy.venue.postcodeId = venue.id;
        }
        dataCopy.venue.venueType = getVenueTypeByPostcode(venue, activeSchool);
        break;
      case typeof venue !== 'undefined' && typeof venue.point === 'undefined':
        dataCopy.venue.venueType = getVenueTypeByPostcode(venue, activeSchool);
        break;
      default:
        delete dataCopy.venue;
    }

    {
      const formAdmins = Array.isArray(values.admins) ? (values.admins as AdminItem[]) : [];
      dataCopy.admins = formAdmins
        .filter(a => a.userId && a.permissionId)
        .map(a => ({
          userId: a.userId,
          permissionId: a.permissionId
        }));
    }

    this.onSaveButtonClick(dataCopy);
  };

  renderTournamentSubTypeOptions(tournamentType) {
    switch (tournamentType) {
      case TOURNAMENT_TYPE.TEAM_TOURNAMENT:
        return (
          <>
            <option key="subtype_option_football" value={TOURNAMENT_SUBTYPE.FOOTBALL}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.FOOTBALL}
            </option>
            <option key="subtype_option_cricket" value={TOURNAMENT_SUBTYPE.CRICKET}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.CRICKET}
            </option>
            <option key="subtype_option_sailing" value={TOURNAMENT_SUBTYPE.SAILING}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.SAILING}
            </option>
            <option key="subtype_option_rugby" value={TOURNAMENT_SUBTYPE.RUGBY}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.RUGBY}
            </option>
            <option key="subtype_option_netball" value={TOURNAMENT_SUBTYPE.NETBALL}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.NETBALL}
            </option>
            <option key="subtype_option_badminton" value={TOURNAMENT_SUBTYPE.BADMINTON}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.BADMINTON}
            </option>
            <option key="subtype_option_swimming" value={TOURNAMENT_SUBTYPE.WINNERS_ONLY}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.WINNERS_ONLY}
            </option>
          </>
        );
      case TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT:
        return (
          <>
            <option key="subtype_option_swimming" value={TOURNAMENT_SUBTYPE.ATHLETIC_SWIMMING}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.ATHLETIC_SWIMMING}
            </option>
            <option key="subtype_option_regular_individual" value={TOURNAMENT_SUBTYPE.REGULAR_INDIVIDUAL}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.REGULAR_INDIVIDUAL}
            </option>
            <option key="subtype_option_triathlon" value={TOURNAMENT_SUBTYPE.TRIATHLON}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.TRIATHLON}
            </option>
            <option key="subtype_option_national_triathlon" value={TOURNAMENT_SUBTYPE.NATIONAL_TRIATHLON}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.NATIONAL_TRIATHLON}
            </option>
            <option key="subtype_option_cross_country" value={TOURNAMENT_SUBTYPE.CROSS_COUNTRY}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.CROSS_COUNTRY}
            </option>
            <option key="subtype_option_national_cross_country" value={TOURNAMENT_SUBTYPE.NATIONAL_CROSS_COUNTRY}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.NATIONAL_CROSS_COUNTRY}
            </option>
            <option key="subtype_option_pseudo_two_level" value={TOURNAMENT_SUBTYPE.PSEUDO_TWO_LEVEL}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.PSEUDO_TWO_LEVEL}
            </option>
            <option key="subtype_option_pseudo_two_level_runtime" value={TOURNAMENT_SUBTYPE.PSEUDO_TWO_LEVEL_RUNTIME}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.PSEUDO_TWO_LEVEL_RUNTIME}
            </option>
          </>
        );
      case TOURNAMENT_TYPE.SINGLE_DOUBLE_TOURNAMENT:
        return (
          <>
            <option key="subtype_option_badminton" value={TOURNAMENT_SUBTYPE.BADMINTON}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.BADMINTON}
            </option>
            <option key="subtype_option_fencing" value={TOURNAMENT_SUBTYPE.FENCING}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.FENCING}
            </option>
            <option key="subtype_option_tennis" value={TOURNAMENT_SUBTYPE.TENNIS}>
              {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.TENNIS}
            </option>
          </>
        );
      case TOURNAMENT_TYPE.MINI_TEAM_TOURNAMENT:
        return (
          <option key="subtype_option_badminton" value={TOURNAMENT_SUBTYPE.BADMINTON_MT}>
            {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING.BADMINTON_MT}
          </option>
        );
    }
  }

  onCloseFormFieldListAnnouncementClick = index => {
    const { announcements } = this.state;
    const currentAnnouncements = announcements.slice();
    currentAnnouncements.splice(index, 1);

    this.setState({
      announcements: currentAnnouncements,
      auxiliaryDirty: true
    });
  };

  onCloseFormFieldListNationalGoverningBodyClick = index => {
    const { nationalGoverningBodies } = this.state;
    const currentNationalGoverningBodies = nationalGoverningBodies.slice();
    currentNationalGoverningBodies.splice(index, 1);

    this.setState({
      nationalGoverningBodies: currentNationalGoverningBodies,
      auxiliaryDirty: true
    });
  };

  onCloseFormFieldListSponsorClick = index => {
    const sponsors = this.state.sponsors.slice();
    sponsors.splice(index, 1);
    this.setState({ sponsors, auxiliaryDirty: true });
  };

  onGlobalAnnouncementsFormChange = (event, index, field) => {
    const { announcements } = this.state;
    let changeAnnouncements = announcements.slice();
    switch (true) {
      case field === 'date':
        const date = event; //  for understanding
        changeAnnouncements[index].date = date.toISOString();
        break;
      case field === 'isDateVisible':
        changeAnnouncements[index].isDateVisible = event.target.checked;
        break;
      case field === 'removeImageButton':
        changeAnnouncements[index].attachments.images[0].url = '';
        break;
      case field === 'body':
        const text = event;
        changeAnnouncements[index].body = text;
        break;
      case field === 'title':
        changeAnnouncements[index].title = event.target.value;
        break;
      case field === 'uploadImage':
        const url = event;
        changeAnnouncements[index].attachments.images[0].url = url;
        break;
      case field === 'removeFileButton':
        const fileIndex = event;
        changeAnnouncements[index].attachments.files.splice(fileIndex, 1);
        break;
      case field === 'uploadFile':
        const { user } = this.props;
        const file = event.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        const fileName = event.target.files[0].name;
        uploadFile(user, formData).then(data => {
          const key = data.key;
          changeAnnouncements[index].attachments.files.push({
            name: fileName,
            url: key
          });
          this.setState({ announcements: changeAnnouncements, auxiliaryDirty: true });
        });
        return;
    }

    this.setState({
      announcements: changeAnnouncements,
      auxiliaryDirty: true
    });
  };

  onGlobalNationalGoverningBodiesFormChange = (event, index, field) => {
    const { nationalGoverningBodies } = this.state;
    let changeNationalGoverningBodies = nationalGoverningBodies.slice();
    switch (true) {
      case field === 'removeImageButton':
        changeNationalGoverningBodies[index].picUrl = '';
        break;
      case field === 'link':
        changeNationalGoverningBodies[index].link = event.target.value;
        break;
      case field === 'name':
        changeNationalGoverningBodies[index].name = event.target.value;
        break;
      case field === 'uploadImage':
        const url = event;
        changeNationalGoverningBodies[index].picUrl = url;
        break;
    }

    this.setState({
      nationalGoverningBodies: changeNationalGoverningBodies,
      auxiliaryDirty: true
    });
  };

  onGlobalSponsorsFormChange = (event, index, field) => {
    const sponsors = this.state.sponsors.slice();
    switch (field) {
      case 'removeImageButton':
        sponsors[index].picUrl = '';
        break;
      case 'link':
        sponsors[index].link = event.target.value;
        break;
      case 'name':
        sponsors[index].name = event.target.value;
        break;
      case 'uploadImage':
        sponsors[index].picUrl = event;
        break;
    }
    this.setState({ sponsors, auxiliaryDirty: true });
  };

  renderFormFieldListAnnouncements() {
    const { announcements } = this.state;
    if (!announcements.length) return <div className="utCreateWizard__optionalEmpty">No custom sections added.</div>;
    return announcements.map((announcement, index) => (
      <div className="utCreateWizard__optionalCard" key={`announcement_${index}`}>
        <button
          type="button"
          className="utCreateWizard__optionalCardPreview"
          onClick={() => this.setState({ previewAnnouncementIndex: index })}
        >
          <b>{announcement.title || `Untitled section ${index + 1}`}</b>
          <small>{announcement.body ? 'Click to preview' : 'No content yet'}</small>
        </button>
        <div>
          <button
            type="button"
            disabled={index === 0}
            onClick={() => this.moveOptionalItem('announcements', index, -1)}
          >
            ↑
          </button>
          <button
            type="button"
            disabled={index === announcements.length - 1}
            onClick={() => this.moveOptionalItem('announcements', index, 1)}
          >
            ↓
          </button>
          <button
            type="button"
            onClick={() => this.setState({ editingAnnouncementIndex: index, optionalEditorIsNew: false })}
          >
            Edit
          </button>
          <button type="button" onClick={() => this.onCloseFormFieldListAnnouncementClick(index)}>
            Remove
          </button>
        </div>
      </div>
    ));
  }

  onClickAddCustomSectionForm = (): void => {
    const { announcements } = this.state;
    const newAnnouncements = announcements.slice();
    newAnnouncements.push({
      attachments: {
        files: [],
        images: [
          {
            url: ''
          }
        ]
      },
      body: '',
      date: new Date(),
      isDateVisible: false,
      title: ''
    });

    this.setState({
      announcements: newAnnouncements,
      editingAnnouncementIndex: newAnnouncements.length - 1,
      optionalEditorIsNew: true,
      auxiliaryDirty: true
    });
  };

  renderFormFieldListGoverningBodies() {
    const { nationalGoverningBodies } = this.state;
    if (!nationalGoverningBodies.length) {
      return <div className="utCreateWizard__optionalEmpty">No governing bodies added.</div>;
    }
    return nationalGoverningBodies.map((item, index) => (
      <div className="utCreateWizard__optionalCard" key={`nationalGoverningBody_${index}`}>
        <span>
          <b>{item.name || `Unnamed organisation ${index + 1}`}</b>
          <small>{item.link || 'No website link'}</small>
        </span>
        <div>
          <button
            type="button"
            disabled={index === 0}
            onClick={() => this.moveOptionalItem('nationalGoverningBodies', index, -1)}
          >
            ↑
          </button>
          <button
            type="button"
            disabled={index === nationalGoverningBodies.length - 1}
            onClick={() => this.moveOptionalItem('nationalGoverningBodies', index, 1)}
          >
            ↓
          </button>
          <button
            type="button"
            onClick={() => this.setState({ editingGoverningBodyIndex: index, optionalEditorIsNew: false })}
          >
            Edit
          </button>
          <button type="button" onClick={() => this.onCloseFormFieldListNationalGoverningBodyClick(index)}>
            Remove
          </button>
        </div>
      </div>
    ));
  }

  onClickAddGoverningBodiesForm = (): void => {
    const { nationalGoverningBodies } = this.state;
    const newNationalGoverningBodies = nationalGoverningBodies.slice();
    newNationalGoverningBodies.push({
      link: '',
      picUrl: '',
      name: ''
    });

    this.setState({
      nationalGoverningBodies: newNationalGoverningBodies,
      editingGoverningBodyIndex: newNationalGoverningBodies.length - 1,
      optionalEditorIsNew: true,
      auxiliaryDirty: true
    });
  };

  renderFormFieldListSponsors() {
    const { sponsors } = this.state;
    if (!sponsors.length) return <div className="utCreateWizard__optionalEmpty">No sponsors added.</div>;
    return sponsors.map((item, index) => (
      <div className="utCreateWizard__optionalCard" key={`sponsor_${index}`}>
        <span>
          <b>{item.name || `Unnamed sponsor ${index + 1}`}</b>
          <small>{item.link || 'No website link'}</small>
        </span>
        <div>
          <button type="button" disabled={index === 0} onClick={() => this.moveOptionalItem('sponsors', index, -1)}>
            ↑
          </button>
          <button
            type="button"
            disabled={index === sponsors.length - 1}
            onClick={() => this.moveOptionalItem('sponsors', index, 1)}
          >
            ↓
          </button>
          <button
            type="button"
            onClick={() => this.setState({ editingSponsorIndex: index, optionalEditorIsNew: false })}
          >
            Edit
          </button>
          <button type="button" onClick={() => this.onCloseFormFieldListSponsorClick(index)}>
            Remove
          </button>
        </div>
      </div>
    ));
  }

  onClickAddSponsorForm = (): void => {
    const sponsors = [...this.state.sponsors, { link: '', picUrl: '', name: '' }];
    this.setState({
      sponsors,
      editingSponsorIndex: sponsors.length - 1,
      optionalEditorIsNew: true,
      auxiliaryDirty: true
    });
  };

  moveOptionalItem = (
    field: 'announcements' | 'nationalGoverningBodies' | 'sponsors',
    index: number,
    offset: number
  ) => {
    const items = [...(this.state[field] as any[])];
    const nextIndex = index + offset;
    if (nextIndex < 0 || nextIndex >= items.length) return;
    [items[index], items[nextIndex]] = [items[nextIndex], items[index]];
    this.setState({ [field]: items, auxiliaryDirty: true } as any);
  };

  closeOptionalEditor = (kind: 'announcement' | 'governingBody' | 'sponsor', discardNew = false) => {
    const index =
      kind === 'announcement'
        ? this.state.editingAnnouncementIndex
        : kind === 'governingBody'
        ? this.state.editingGoverningBodyIndex
        : this.state.editingSponsorIndex;
    if (discardNew && this.state.optionalEditorIsNew && typeof index === 'number') {
      if (kind === 'announcement') this.onCloseFormFieldListAnnouncementClick(index);
      else if (kind === 'governingBody') this.onCloseFormFieldListNationalGoverningBodyClick(index);
      else this.onCloseFormFieldListSponsorClick(index);
    }
    this.setState({
      editingAnnouncementIndex: undefined,
      editingGoverningBodyIndex: undefined,
      editingSponsorIndex: undefined,
      optionalEditorIsNew: false
    });
  };

  renderOptionalEditors() {
    const { user } = this.props;
    const {
      editingAnnouncementIndex,
      editingGoverningBodyIndex,
      editingSponsorIndex,
      announcements,
      nationalGoverningBodies,
      sponsors
    } = this.state;
    return (
      <>
        <SimpleModal
          isOpen={typeof editingAnnouncementIndex === 'number'}
          title="Custom section"
          customClass="utCreateWizard__customSectionModal"
          showFooter={false}
          onCloseClick={() => this.closeOptionalEditor('announcement', true)}
          dialogStyle={{ maxWidth: 760 }}
        >
          {typeof editingAnnouncementIndex === 'number' && announcements[editingAnnouncementIndex] ? (
            <>
              <TournamentCustomSectionForm
                announcement={announcements[editingAnnouncementIndex]}
                onGlobalAnnouncementsFormChange={this.onGlobalAnnouncementsFormChange}
                user={user}
                onCloseClick={() => this.closeOptionalEditor('announcement', true)}
                announcementIndex={editingAnnouncementIndex}
              />
              <div className="utCreateWizard__optionalModalFooter">
                <button type="button" onClick={() => this.closeOptionalEditor('announcement', true)}>
                  Cancel
                </button>
                <button type="button" className="is-primary" onClick={() => this.closeOptionalEditor('announcement')}>
                  Done
                </button>
              </div>
            </>
          ) : null}
        </SimpleModal>
        <SimpleModal
          isOpen={typeof editingGoverningBodyIndex === 'number'}
          title="National Governing Body"
          customClass="utCreateWizard__customSectionModal"
          showFooter={false}
          onCloseClick={() => this.closeOptionalEditor('governingBody', true)}
          dialogStyle={{ maxWidth: 620 }}
        >
          {typeof editingGoverningBodyIndex === 'number' && nationalGoverningBodies[editingGoverningBodyIndex] ? (
            <>
              <TournamentNationalGoverningBodiesForm
                nationalGoverningBody={nationalGoverningBodies[editingGoverningBodyIndex]}
                onGlobalNationalGoverningBodiesFormChange={this.onGlobalNationalGoverningBodiesFormChange}
                user={user}
                onCloseClick={() => this.closeOptionalEditor('governingBody', true)}
                nationalGoverningBodyIndex={editingGoverningBodyIndex}
              />
              <div className="utCreateWizard__optionalModalFooter">
                <button type="button" onClick={() => this.closeOptionalEditor('governingBody', true)}>
                  Cancel
                </button>
                <button type="button" className="is-primary" onClick={() => this.closeOptionalEditor('governingBody')}>
                  Done
                </button>
              </div>
            </>
          ) : null}
        </SimpleModal>
        <SimpleModal
          isOpen={typeof editingSponsorIndex === 'number'}
          title="Sponsor"
          customClass="utCreateWizard__customSectionModal"
          showFooter={false}
          onCloseClick={() => this.closeOptionalEditor('sponsor', true)}
          dialogStyle={{ maxWidth: 620 }}
        >
          {typeof editingSponsorIndex === 'number' && sponsors[editingSponsorIndex] ? (
            <>
              <TournamentNationalGoverningBodiesForm
                nationalGoverningBody={sponsors[editingSponsorIndex]}
                onGlobalNationalGoverningBodiesFormChange={this.onGlobalSponsorsFormChange}
                user={user}
                onCloseClick={() => this.closeOptionalEditor('sponsor', true)}
                nationalGoverningBodyIndex={editingSponsorIndex}
              />
              <div className="utCreateWizard__optionalModalFooter">
                <button type="button" onClick={() => this.closeOptionalEditor('sponsor', true)}>
                  Cancel
                </button>
                <button type="button" className="is-primary" onClick={() => this.closeOptionalEditor('sponsor')}>
                  Done
                </button>
              </div>
            </>
          ) : null}
        </SimpleModal>
        <SimpleModal
          isOpen={typeof this.state.previewAnnouncementIndex === 'number'}
          title={
            typeof this.state.previewAnnouncementIndex === 'number'
              ? announcements[this.state.previewAnnouncementIndex]?.title || 'Custom section preview'
              : 'Custom section preview'
          }
          showFooter={false}
          onCloseClick={() => this.setState({ previewAnnouncementIndex: undefined })}
          dialogStyle={{ maxWidth: 760 }}
        >
          {typeof this.state.previewAnnouncementIndex === 'number' &&
          announcements[this.state.previewAnnouncementIndex] ? (
            <div className="utCreateWizard__sectionPreview">
              {announcements[this.state.previewAnnouncementIndex].isDateVisible ? (
                <time>
                  {moment(announcements[this.state.previewAnnouncementIndex].date).format('DD MMM YYYY, HH:mm')}
                </time>
              ) : null}
              {propz.get(
                announcements[this.state.previewAnnouncementIndex],
                ['attachments', 'images', '0', 'url'],
                ''
              ) ? (
                <img
                  src={propz.get(
                    announcements[this.state.previewAnnouncementIndex],
                    ['attachments', 'images', '0', 'url'],
                    ''
                  )}
                  alt=""
                />
              ) : null}
              <div
                dangerouslySetInnerHTML={{
                  __html: announcements[this.state.previewAnnouncementIndex].body || '<p>No content added.</p>'
                }}
              />
            </div>
          ) : null}
        </SimpleModal>
      </>
    );
  }

  renderTagModal() {
    const { tagDraft } = this.state;
    const update = patch => this.setState({ tagDraft: { ...this.state.tagDraft, ...patch } });
    const close = () =>
      this.setState({
        isTagModalOpen: false,
        tagDraft: { tagName: '', tagDescription: '', tagColor: '#227ebd', isPublic: false }
      });
    const save = () => {
      if (!tagDraft.tagName.trim()) return;
      createTournamentTag(this.props.user, { ...tagDraft, tagName: tagDraft.tagName.trim() }).then((tag: any) => {
        const created = tag.tournamentTag || tag;
        this.setState(state => ({
          tournamentTagOptions: [...state.tournamentTagOptions, created],
          selectedTournamentTagIds: [...state.selectedTournamentTagIds, String(created.id || created._id)],
          isTagModalOpen: false,
          tagDraft: { tagName: '', tagDescription: '', tagColor: '#227ebd', isPublic: false },
          auxiliaryDirty: true
        }));
      });
    };
    return (
      <SimpleModal
        isOpen={this.state.isTagModalOpen}
        title="Create tournament tag"
        showFooter={false}
        onCloseClick={close}
        dialogStyle={{ maxWidth: 460 }}
      >
        <div className="utCreateWizard__tagModal">
          <label>
            Name
            <input value={tagDraft.tagName} onChange={event => update({ tagName: event.target.value })} autoFocus />
          </label>
          <label>
            Description
            <textarea
              rows={3}
              value={tagDraft.tagDescription}
              onChange={event => update({ tagDescription: event.target.value })}
            />
          </label>
          <label className="is-colour">
            Colour
            <input
              type="color"
              value={tagDraft.tagColor}
              onChange={event => update({ tagColor: event.target.value })}
            />
          </label>
          <div className="utCreateWizard__settingRow">
            <span>
              <b>Public tag</b>
              <small>Public tags may be shown outside the union admin area.</small>
            </span>
            <Switch
              name="newTagIsPublic"
              value={tagDraft.isPublic}
              onChange={() => update({ isPublic: !tagDraft.isPublic })}
            />
          </div>
          <footer>
            <button type="button" onClick={close}>
              Cancel
            </button>
            <button type="button" className="is-primary" disabled={!tagDraft.tagName.trim()} onClick={save}>
              Create tag
            </button>
          </footer>
        </div>
      </SimpleModal>
    );
  }

  getNewPoint = pointNew => {
    this.setState({
      point: pointNew
    });
  };

  onCancelCreateVenueFormOpenClick = (): void => {
    this.setState({
      isCreateVenueFormOpen: false
    });
  };

  isDeleteButton() {
    const { venue } = this.state;
    const venueName = propz.get(venue, ['name'], undefined);
    return venueName !== undefined;
  }

  deleteVenueModalOpen = (): void => {
    this.setState({
      isDeleteVenueModalOpen: true
    });
  };

  createVenueFormOpen = (): void => {
    this.setState({
      isCreateVenueFormOpen: true
    });
  };

  onDeleteVenueClick = venue => {
    const { user } = this.props;
    const { activeSchool } = user;
    const { tournament, point } = this.state;
    deleteVenue(user, venue.placeId).then(res => {
      let oldVenue;
      let oldPoint;

      switch (true) {
        case typeof tournament === 'undefined':
          oldVenue = getHomeSchoolPostCode(activeSchool);
          oldPoint = getDefaultPoint(user);
          break;
        case typeof tournament.venue !== 'undefined' &&
          typeof tournament.venue.postcodeId !== 'undefined' &&
          venue.id === tournament.venue.postcodeId:
          oldVenue = getHomeSchoolPostCode(activeSchool);
          oldPoint = getDefaultPoint(user);
          break;
        default:
          oldVenue = getDefaultTournamentPostcode(tournament, user.activeSchool);
          oldPoint = point;
          break;
      }
      this.setState({
        isDeleteVenueModalOpen: false,
        venue: oldVenue,
        point: oldPoint
      });
    });
  };

  deleteVenueModalClose = (): void => {
    this.setState({
      isDeleteVenueModalOpen: false
    });
  };

  onSubmitVenueForm = (data): void => {
    const { user } = this.props;

    createVenue(user, data).then(venue => {
      const convertPlace = convertPlaceToPostcodeWithPlaceName(venue);

      if (this.tournamentFormRef.current) {
        this.tournamentFormRef.current.setFieldValue('venue', convertPlace, true);
        this.tournamentFormRef.current.setFieldTouched('venue', true, false);
        this.tournamentFormRef.current.setFieldError('venue', undefined);
      }

      this.setState({
        venue: convertPlace,
        point: convertPlace.point,
        isCreateVenueFormOpen: false
      });
    });
  };

  renderDeleteVenueModal() {
    const { isDeleteVenueModalOpen, venue } = this.state;

    const venueName = propz.get(venue, ['name'], '');
    return (
      <SimpleModal
        isOpen={isDeleteVenueModalOpen}
        title={'Delete venue'}
        body={`Are you sure you want to remove venue ${venueName}`}
        buttonText={'Delete'}
        onButtonClick={() => this.onDeleteVenueClick(venue)}
        onCloseClick={this.deleteVenueModalClose}
      />
    );
  }

  renderCreateVenueForm() {
    const { user } = this.props;
    const { isCreateVenueFormOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isCreateVenueFormOpen}
        title="New venue"
        onCloseClick={this.onCancelCreateVenueFormOpenClick}
        showFooter={false}
        customClass="modal-md"
        dialogStyle={{
          maxWidth: 680
        }}
      >
        <VenueForm user={user} onCancel={this.onCancelCreateVenueFormOpenClick} onSubmit={this.onSubmitVenueForm} />
      </SimpleModal>
    );
  }

  render() {
    const {
      isImageError,
      tournament,
      isLoading,
      coverPhotoUrls,
      isCreateVenueFormOpen,
      isDeleteVenueModalOpen,
      venue
    } = this.state;
    const { user } = this.props;
    const isTournamentExists = this.isTournamentExist();
    const mode = this.getMode();
    const positiveButtonTitle = isTournamentExists ? 'Save tournament' : 'Create tournament';

    const modeCopy = mode === MODE_TYPE.COPY;

    const hadEntriesOpenBefore =
      isTournamentExists &&
      !modeCopy &&
      typeof tournament !== 'undefined' &&
      typeof tournament.entriesOpen !== 'undefined' &&
      tournament.entriesOpen !== null;

    const hadDeadlineForEntriesBefore =
      isTournamentExists &&
      !modeCopy &&
      typeof tournament !== 'undefined' &&
      typeof tournament.deadlineForEntries !== 'undefined' &&
      tournament.deadlineForEntries !== null;

    const point = this.state.point;
    const mainTitle = isTournamentExists ? 'Edit tournament' : 'Add a new tournament';
    const isPaymentsEnabled = propz.get(this.props, ['user', 'activeSchool', 'isPaymentsEnabled'], false);
    const defaultPaymentAccountId = propz.get(tournament, ['paymentSettings', 'paymentAccountId'], undefined);
    const defaultPaymentAccountName = propz.get(tournament, ['paymentSettings', 'paymentAccountName'], undefined);
    const defaultPaymentsAccount =
      typeof defaultPaymentAccountId !== 'undefined' && typeof defaultPaymentAccountName !== 'undefined'
        ? { id: defaultPaymentAccountId, name: defaultPaymentAccountName }
        : undefined;
    const entriesOpen =
      typeof tournament !== 'undefined' &&
      typeof tournament.entriesOpen !== 'undefined' &&
      tournament.entriesOpen !== null
        ? new Date(tournament.entriesOpen)
        : '';
    const deadlineForEntries =
      typeof tournament !== 'undefined' &&
      typeof tournament.deadlineForEntries !== 'undefined' &&
      tournament.deadlineForEntries !== null
        ? new Date(tournament.deadlineForEntries)
        : '';

    const hintTextResultMask =
      'h:  -hours\nm:  -minutes or meters\ns.  -seconds\nc  -split second or centimeters\nseparator : and .\n\n' +
      '(for example \nh:mm:ss.ccc   -  for time\nor\nm.c  -   for distances)';

    if (isLoading) {
      return <Loader />;
    }

    const transformPositions = tournamentPositionsArray => {
      if (!Array.isArray(tournamentPositionsArray)) {
        return {};
      }
      return tournamentPositionsArray.reduce((acc, pos) => {
        acc[`${pos.year}_${pos.gender}`] = pos.count;
        return acc;
      }, {});
    };

    const initialTournamentType = isTournamentExists
      ? propz.get(tournament, ['type'], TOURNAMENT_TYPE.TEAM_TOURNAMENT)
      : TOURNAMENT_TYPE.TEAM_TOURNAMENT;
    const storedScoring = isTournamentExists ? this.getScoring() : '3, 2, 1, 0';
    const initialScoring =
      initialTournamentType === TOURNAMENT_TYPE.TEAM_TOURNAMENT &&
      storedScoring.split(',').filter(value => value.trim()).length !== 4
        ? '3, 2, 1, 0'
        : storedScoring;

    const tournamentInitial: TournamentFormValues = {
      name: isTournamentExists ? propz.get(tournament, ['name'], '') : '',
      description: isTournamentExists ? propz.get(tournament, ['description'], '') : '',
      ageGroups: isTournamentExists ? propz.get(tournament, ['ages'], []) : [],
      gender: isTournamentExists ? propz.get(tournament, ['gender'], '') : '',
      startTime: isTournamentExists && !modeCopy ? new Date(propz.get(tournament, ['startTime'], '')) : '',
      endTime: isTournamentExists && !modeCopy ? new Date(propz.get(tournament, ['endTime'], '')) : '',
      isAgeGroupsOnWebSiteVisible: getYesOrNoForBoolean(propz.get(tournament, ['isAgeGroupsOnWebSiteVisible'], false)),
      isMixedTeamsAvailable: getYesOrNoForBoolean(propz.get(tournament, ['isMixedTeamsAvailable'], false)),
      isSchoolCanSubmitResult: getYesOrNoForBoolean(propz.get(tournament, ['isSchoolCanSubmitResult'], false)),
      resultPublishingMode: propz.get(tournament, ['resultPublishingMode'], 'IMMEDIATE'),
      supportsHalfTime: propz.get(tournament, ['resultCapabilities', 'supportsHalfTime'], false),
      supportsExtraTime: propz.get(tournament, ['resultCapabilities', 'supportsExtraTime'], false),
      supportsShootout: propz.get(tournament, ['resultCapabilities', 'supportsShootout'], false),
      supportsScorers: propz.get(tournament, ['resultCapabilities', 'supportsScorers'], false),
      scorerTimePrecision: propz.get(tournament, ['resultCapabilities', 'scorerTimePrecision'], 'NONE'),
      defaultEventDurationMinutes: propz.get(tournament, ['eventDefaults', 'durationMinutes'], 60),
      isShowTwitter: getYesOrNoForBoolean(propz.get(tournament, ['isShowTwitter'], false)),
      tournamentType: initialTournamentType,
      tournamentSubType: isTournamentExists
        ? propz.get(tournament, ['subType'], TOURNAMENT_SUBTYPE.FOOTBALL)
        : TOURNAMENT_SUBTYPE.FOOTBALL,
      sport: propz.get(tournament, ['sport'], undefined),
      sportId: propz.get(tournament, ['sportId'], ''),
      scoring: initialScoring,
      organisers: isTournamentExists ? propz.get(tournament, ['organisers'], '') : '',
      organisersEmail: isTournamentExists ? propz.get(tournament, ['organisersEmail'], '') : '',
      admins: isTournamentExists
        ? (propz.get(tournament, ['admins'], []) as any[]).map(a => ({
            userId: a.userId,
            permissionId: a.permissionId,
            name: [a.firstName, a.lastName].filter(Boolean).join(' ')
          }))
        : [],
      useAdminsForNotifications: isTournamentExists
        ? propz.get(tournament, ['useAdminsForNotifications'], false)
        : true,
      priceType: propz.get(tournament, ['price', 'priceType'], TOURNAMENT_PRICE_TYPE.FREE),
      isPaymentSettingsVisible: this.state.isPaymentSettingsVisible,
      paymentType: propz.get(tournament, ['price', 'paymentType'], TOURNAMENT_PAYMENT_TYPE.FIXED_PRICE),
      price: propz.get(tournament, ['price', 'price'], 0),
      paymentAccountId: propz.get(tournament, ['paymentSettings', 'paymentAccountId'], 0),
      paymentAccountCurrent: defaultPaymentsAccount,
      isAdvancedSettingsVisible: this.state.isAdvancedSettingsVisible,
      entriesOpen: modeCopy ? '' : entriesOpen || '',
      deadlineForEntries: modeCopy ? '' : deadlineForEntries || '',
      isWhenSpacesAreFull: getYesOrNoForBoolean(propz.get(tournament, ['isWhenSpacesAreFull'], false)),
      tournamentStreamIsEnabled: getYesOrNoForBoolean(propz.get(tournament, ['tournamentStream', 'isEnabled'], false)),
      tournamentStreamUrl: propz.get(tournament, ['tournamentStream', 'url'], ''),
      resultImportPropertiesFieldsPlayerNumber: propz.get(
        tournament,
        ['resultImportProperties', 'fields', 'playerNumber'],
        DEFAULT_EVENT_IMPORT_PROPERTIES.playerNumber
      ),
      resultImportPropertiesFieldsTeamCode: propz.get(
        tournament,
        ['resultImportProperties', 'fields', 'teamCode'],
        DEFAULT_EVENT_IMPORT_PROPERTIES.teamCode
      ),
      resultImportPropertiesFieldsResult: propz.get(
        tournament,
        ['resultImportProperties', 'fields', 'result'],
        DEFAULT_EVENT_IMPORT_PROPERTIES.result
      ),
      resultImportPropertiesFieldsDelimiter: propz.get(
        tournament,
        ['resultImportProperties', 'fields', 'delimiter'],
        DEFAULT_EVENT_IMPORT_PROPERTIES.delimiter
      ),
      resultImportPropertiesResultMask: propz.get(tournament, ['resultImportProperties', 'resultMask'], ''),
      venue: venue,
      maxPlayersPerTeam: isTournamentExists ? propz.get(tournament, ['maxPlayersPerTeam'], 0) : 0,
      isEventParticipantLimitEnforced: isTournamentExists
        ? propz.get(tournament, ['isEventParticipantLimitEnforced'], true)
        : true,
      maxIndividualEventsPerStudent: isTournamentExists
        ? propz.get(tournament, ['maxIndividualEventsPerStudent'], 0)
        : 0,
      maxRelayEventsPerStudent: isTournamentExists ? propz.get(tournament, ['maxRelayEventsPerStudent'], 0) : 0,
      halfScoreForNetball: isTournamentExists ? propz.get(tournament, ['halfScoreForNetball'], false) : false,
      positionsCountForTeamPoints: isTournamentExists
        ? transformPositions(propz.get(tournament, ['positionsCountForTeamPoints'], []))
        : {}
    };

    const wizardPageClass = this.isCreateWizardMode() ? 'utCreateWizardPage' : 'mt-3';
    const classes = `${wizardPageClass}${isCreateVenueFormOpen || isDeleteVenueModalOpen ? ' modal-open' : ''}`;

    return (
      <div className={classes}>
        {this.renderCreateVenueForm()}
        {this.renderDeleteVenueModal()}
        {this.renderTagModal()}
        <Formik<TournamentFormValues>
          innerRef={this.tournamentFormRef}
          onSubmit={value => {
            this.onSubmit(value);
          }}
          initialValues={tournamentInitial}
          validationSchema={buildTournamentValidationSchema({
            allowPastEntriesOpen: hadEntriesOpenBefore,
            allowPastDeadlineForEntries: hadDeadlineForEntriesBefore
          })}
        >
          {({
            values,
            setFieldValue,
            setFieldTouched,
            setFieldError,
            setTouched,
            validateForm,
            submitForm,
            touched,
            errors,
            submitCount,
            dirty
          }) => {
            const startTimeDate =
              values.startTime && moment(values.startTime).isValid() ? moment(values.startTime).toDate() : null;

            const deadlineDate =
              values.deadlineForEntries && moment(values.deadlineForEntries).isValid()
                ? moment(values.deadlineForEntries).toDate()
                : null;

            const showDeadlineAfterStartWarning =
              !!deadlineDate && !!startTimeDate && deadlineDate.getTime() > startTimeDate.getTime();

            const isCreateWizard = this.isCreateWizardMode();
            const wizardSteps = [
              { title: 'Basics', description: 'Name, sport and eligibility' },
              { title: 'Schedule & venue', description: 'Dates, booking and location' },
              { title: 'Competition & contacts', description: 'Scoring, match results and organisers' },
              { title: 'Appearance', description: 'Cover, visibility and tags' },
              { title: 'Custom sections', description: 'Optional public content' },
              { title: 'Governing bodies', description: 'Optional partner organisations' },
              { title: 'Sponsors', description: 'Tournament sponsors and links' },
              { title: 'Review & options', description: 'Payments and advanced settings' }
            ];
            const goToNextWizardStep = async () => {
              const fieldsByStep = [
                ['name', 'sportId', 'tournamentType', 'tournamentSubType', 'gender', 'ageGroups'],
                ['startTime', 'endTime', 'venue'],
                ['scoring'],
                [],
                [],
                [],
                [],
                []
              ];
              const fields = fieldsByStep[this.state.wizardStep] || [];
              const formErrors: any = await validateForm();
              const stepErrors = fields.filter(field => formErrors[field]);
              if (this.state.wizardStep === 1 && !isTournamentVenueSelected(values.venue)) {
                if (!stepErrors.includes('venue')) stepErrors.push('venue');
                setFieldError('venue', 'Venue is required');
              }
              if (stepErrors.length) {
                setTouched(
                  stepErrors.reduce((result, field) => ({ ...result, [field]: true }), {}),
                  false
                );
                return;
              }
              this.setState(state => {
                const wizardStep = Math.min(wizardSteps.length - 1, state.wizardStep + 1);
                return { wizardStep, wizardMaxStep: Math.max(state.wizardMaxStep, wizardStep) };
              });
              window.scrollTo({ top: 0, behavior: 'smooth' });
            };
            const submitWizard = async () => {
              const formErrors: any = await validateForm();
              const errorFields = Object.keys(formErrors);
              if (errorFields.length) {
                const stepFields = [
                  ['name', 'sportId', 'tournamentType', 'tournamentSubType', 'gender', 'ageGroups'],
                  ['startTime', 'endTime', 'entriesOpen', 'deadlineForEntries', 'venue'],
                  [
                    'scoring',
                    'organisers',
                    'organisersEmail',
                    'admins',
                    'maxPlayersPerTeam',
                    'maxIndividualEventsPerStudent',
                    'maxRelayEventsPerStudent'
                  ],
                  [],
                  [],
                  [],
                  errorFields
                ];
                const firstErrorStep = stepFields.findIndex(fields =>
                  fields.some(field => errorFields.includes(field))
                );
                setTouched(
                  errorFields.reduce((result, field) => ({ ...result, [field]: true }), {}),
                  false
                );
                this.setState({ wizardStep: firstErrorStep < 0 ? 0 : firstErrorStep });
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
              }
              submitForm();
            };
            const hasUnsavedWizardChanges = dirty || this.state.auxiliaryDirty;
            const requestCancel = () => {
              if (hasUnsavedWizardChanges) this.setState({ isCancelConfirmationOpen: true });
              else this.onCancelButtonClick();
            };

            const audienceLabel = values.gender
              ? values.gender
                  .replace('_ONLY', '')
                  .toLowerCase()
                  .replace(/^./, value => value.toUpperCase())
              : 'Audience not set';
            const rawScoringValues = String(values.scoring || '')
              .split(',')
              .map(value => value.trim());
            const scoringValues = rawScoringValues.filter(Boolean);
            const isTeamScoring = values.tournamentType === TOURNAMENT_TYPE.TEAM_TOURNAMENT;
            const isNetballScoring = isTeamScoring && values.tournamentSubType === TOURNAMENT_SUBTYPE.NETBALL;
            const teamScoringDefaults = ['3', '2', '1', '0'];
            const teamScoringValues = teamScoringDefaults.map((fallback, index) => rawScoringValues[index] ?? fallback);
            const teamScoringLabels = isNetballScoring
              ? ['Win', 'Draw', 'Qualifying loss', 'Other loss']
              : ['Win', 'Scoring draw', 'Goalless draw', 'Loss'];
            const updateTeamScoring = (index: number, nextValue: string) => {
              const next = [...teamScoringValues];
              next[index] = nextValue.replace(/\D/g, '');
              setFieldValue('scoring', next.join(', '));
            };

            return (
              <Form className={isCreateWizard ? 'utCreateWizard' : ''}>
                {this.renderOptionalEditors()}
                <UnsavedChangesModal
                  isOpen={this.state.isCancelConfirmationOpen}
                  message="You have made changes to this tournament. If you leave now, everything entered in the wizard will be lost."
                  onKeepEditing={this.keepEditing}
                  onDiscard={this.discardChangesAndLeave}
                />
                {!isCreateWizard ? <div className="font-weight-bold">{mainTitle}</div> : null}
                {isCreateWizard ? (
                  <div className="utCreateWizard__context">
                    <span className="utCreateWizard__contextIcon" aria-hidden="true">
                      <svg viewBox="0 0 24 24">
                        <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0zM7 5H4v2a3 3 0 0 0 3 3M17 5h3v2a3 3 0 0 1-3 3" />
                      </svg>
                    </span>
                    <span className="utCreateWizard__contextCopy">
                      <strong>{values.name || 'New tournament'}</strong>
                      <small>
                        {values.sport?.name || 'Sport not set'} · {audienceLabel} ·{' '}
                        {formatTournamentAges(values.ageGroups) || 'Ages not set'}
                        {values.startTime && moment(values.startTime).isValid()
                          ? ` · ${moment(values.startTime).format('DD MMM YYYY')}`
                          : ''}
                      </small>
                    </span>
                    <span className="utCreateWizard__contextSpacer" />
                    <span className="utCreateWizard__contextStep">
                      Step {this.state.wizardStep + 1} of {wizardSteps.length}
                    </span>
                    <span className="utCreateWizard__contextStatus">
                      {mode === MODE_TYPE.EDIT ? 'Editing' : 'Draft'}
                    </span>
                    {dirty ? <span className="utCreateWizard__contextDirty">● Unsaved changes</span> : null}
                  </div>
                ) : null}
                <div className={isCreateWizard ? 'utCreateWizard__card' : ''}>
                  {isCreateWizard ? (
                    <aside className="utCreateWizard__rail">
                      <div className="utCreateWizard__railSteps">
                        {wizardSteps.map((step, index) => (
                          <button
                            key={step.title}
                            type="button"
                            className={`${index === this.state.wizardStep ? 'is-active' : ''} ${
                              index !== this.state.wizardStep && index <= this.state.wizardMaxStep ? 'is-done' : ''
                            }`}
                            disabled={index > this.state.wizardMaxStep}
                            onClick={() => index <= this.state.wizardMaxStep && this.setState({ wizardStep: index })}
                          >
                            <b>
                              {index !== this.state.wizardStep && index <= this.state.wizardMaxStep ? '✓' : index + 1}
                            </b>
                            <span>
                              <strong>{step.title}</strong>
                              <small>{step.description}</small>
                            </span>
                          </button>
                        ))}
                      </div>
                    </aside>
                  ) : null}
                  <main className={isCreateWizard ? 'utCreateWizard__content' : ''}>
                    <div className="row">
                      <div className={`col-md-6 ${isCreateWizard && this.state.wizardStep >= 3 ? 'is-hidden' : ''}`}>
                        <div className="bTournamentFormBlock rounded">
                          <section
                            className={`utCreateWizard__section ${
                              isCreateWizard && this.state.wizardStep !== 0 ? 'is-hidden' : ''
                            }`}
                          >
                            {isCreateWizard ? (
                              <div className="utCreateWizard__sectionTitle">
                                <span>Step 1 of 8</span>
                                <h2>Tell us about the tournament</h2>
                                <p>Choose the format and who the competition is for.</p>
                              </div>
                            ) : null}
                            <div className="form-group">
                              <LabelWithQuestionIcon
                                customClass="bTournamentViewLabel"
                                labelText={
                                  <>
                                    Tournament name <span className="utCreateWizard__required">*</span>
                                  </>
                                }
                                hintText={
                                  "Recommended format: Include the union name and the season. For example, 'ISA U11 Boys Football National Finals 2024/2025'. This helps in clearly identifying the tournament and its specifics."
                                }
                              />
                              <Field
                                type="text"
                                name="name"
                                className={`${
                                  touched.name && errors.name ? 'form-control is-invalid' : 'form-control '
                                }`}
                              />
                              {touched.name && errors.name ? (
                                <div className="alert alert-danger">{errors.name}</div>
                              ) : null}
                            </div>
                            <div className="form-group">
                              <LabelWithQuestionIcon
                                customClass="bTournamentViewLabel"
                                labelText="Description"
                                hintText={
                                  "Use this field to provide essential information that participants and visitors need to see first. For example, you can highlight important announcements, deadlines, or requirements, such as 'Please check the Documents tab of the tournament card to download the program and risk assessment form.' Utilize the available formatting tools to make important details stand out. This ensures that crucial information is clearly visible and can catch the viewer's attention effectively."
                                }
                              />

                              <Field name="description">
                                {({ field, form }) => (
                                  <HTMLEditorQuillHide
                                    user={this.props.user}
                                    value={field.value}
                                    onTextChange={value => form.setFieldValue(field.name, value)}
                                    isEnabled={true}
                                    placeholder="Add important tournament information, announcements or instructions for participants."
                                  />
                                )}
                              </Field>
                              {touched.description && errors.description && (
                                <div className="alert alert-danger">{errors.description}</div>
                              )}
                            </div>

                            <div className="row">
                              {/* Sport Field */}
                              <div className={isCreateWizard ? 'col-md-6 utCreateWizard__basicsSport' : 'col-md-12'}>
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText={
                                      <>
                                        Sport <span className="utCreateWizard__required">*</span>
                                      </>
                                    }
                                    hintText={''}
                                  />
                                  <div className="bTournamentSportMode" role="group" aria-label="Sport catalogue">
                                    <button
                                      type="button"
                                      className={!this.state.isShowAllSports ? 'active' : ''}
                                      onClick={() => this.setState({ isShowAllSports: false })}
                                    >
                                      Favourites
                                    </button>
                                    <button
                                      type="button"
                                      className={this.state.isShowAllSports ? 'active' : ''}
                                      onClick={() => this.setState({ isShowAllSports: true })}
                                    >
                                      All sports
                                    </button>
                                  </div>
                                  <Field name="sport">
                                    {({ field }) => (
                                      <Autocomplete
                                        searchFunction={this.getSports}
                                        getElementTitle={getName}
                                        customClass="mFullWidth mb-3"
                                        defaultItem={values.sport}
                                        onSelect={sport => {
                                          setFieldValue('sportId', sport.id);
                                          setFieldValue('sport', sport);
                                          switch (true) {
                                            case sport.genders.maleOnly:
                                              setFieldValue('gender', GENDER.MALE_ONLY);
                                              setFieldValue('isMixedTeamsAvailable', YES_NO_OPTIONS.NO);
                                              break;
                                            case sport.genders.femaleOnly:
                                              setFieldValue('gender', GENDER.FEMALE_ONLY);
                                              setFieldValue('isMixedTeamsAvailable', YES_NO_OPTIONS.NO);
                                              break;
                                            case sport.genders.mixed:
                                              setFieldValue('gender', GENDER.MIXED);
                                              setFieldValue('isMixedTeamsAvailable', YES_NO_OPTIONS.YES);
                                              break;
                                          }
                                        }}
                                      />
                                    )}
                                  </Field>
                                  {touched.sportId && errors.sportId && (
                                    <div className="alert alert-danger">{errors.sportId}</div>
                                  )}
                                </div>
                              </div>

                              {/* Tournament Type and Subtype Fields */}
                              <div className={isCreateWizard ? 'col-md-6 utCreateWizard__basicsType' : 'col-md-6'}>
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText={
                                      <>
                                        Tournament Type <span className="utCreateWizard__required">*</span>
                                      </>
                                    }
                                    hintText={''}
                                  />
                                  <Field
                                    component="select"
                                    name="tournamentType"
                                    className="form-control"
                                    onChange={event => {
                                      const tournamentType = event.target.value;
                                      setFieldValue('tournamentType', tournamentType);
                                      setFieldValue('ageGroups', []); // Reset ageGroups on type change
                                      if (tournamentType !== TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT) {
                                        setFieldValue('isSchoolCanSubmitResult', YES_NO_OPTIONS.NO);
                                      }
                                      switch (tournamentType) {
                                        case TOURNAMENT_TYPE.TEAM_TOURNAMENT:
                                          setFieldValue('tournamentSubType', TOURNAMENT_SUBTYPE.FOOTBALL);
                                          if (
                                            String(values.scoring || '')
                                              .split(',')
                                              .filter(item => item.trim()).length !== 4
                                          ) {
                                            setFieldValue('scoring', '3, 2, 1, 0');
                                          }
                                          break;
                                        case TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT:
                                          setFieldValue('tournamentSubType', TOURNAMENT_SUBTYPE.REGULAR_INDIVIDUAL);
                                          break;
                                        case TOURNAMENT_TYPE.SINGLE_DOUBLE_TOURNAMENT:
                                          setFieldValue('tournamentSubType', TOURNAMENT_SUBTYPE.BADMINTON);
                                          break;
                                        case TOURNAMENT_TYPE.MINI_TEAM_TOURNAMENT:
                                          setFieldValue('tournamentSubType', TOURNAMENT_SUBTYPE.BADMINTON_MT);
                                          break;
                                      }
                                    }}
                                  >
                                    <option value={TOURNAMENT_TYPE.TEAM_TOURNAMENT}>
                                      {TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING.TEAM_TOURNAMENT}
                                    </option>
                                    <option value={TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT}>
                                      {TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING.INDIVIDUAL_TOURNAMENT}
                                    </option>
                                    <option value={TOURNAMENT_TYPE.SINGLE_DOUBLE_TOURNAMENT}>
                                      {TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING.SINGLE_DOUBLE_TOURNAMENT}
                                    </option>
                                    <option value={TOURNAMENT_TYPE.MINI_TEAM_TOURNAMENT}>
                                      {TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING.MINI_TEAM_TOURNAMENT}
                                    </option>
                                  </Field>
                                </div>
                              </div>

                              <div className={isCreateWizard ? 'col-md-6 utCreateWizard__basicsSubtype' : 'col-md-6'}>
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText={
                                      <>
                                        Tournament Subtype <span className="utCreateWizard__required">*</span>
                                      </>
                                    }
                                    hintText={''}
                                  />
                                  <Field name="tournamentSubType">
                                    {({ field, form }) => (
                                      <select
                                        {...field}
                                        className="form-control"
                                        onChange={event => form.setFieldValue(field.name, event.target.value)}
                                      >
                                        {this.renderTournamentSubTypeOptions(values.tournamentType)}
                                      </select>
                                    )}
                                  </Field>
                                </div>
                              </div>

                              {/* Ages and Gender Fields */}
                              <div className={isCreateWizard ? 'col-md-6 utCreateWizard__basicsGender' : 'col-md-6'}>
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText={
                                      <>
                                        Gender <span className="utCreateWizard__required">*</span>
                                      </>
                                    }
                                    hintText={''}
                                  />
                                  <div className="utCreateWizard__chips" aria-label="Gender">
                                    {[
                                      {
                                        value: GENDER.MALE_ONLY,
                                        label: 'Male',
                                        enabled: values.sport?.genders?.maleOnly
                                      },
                                      {
                                        value: GENDER.FEMALE_ONLY,
                                        label: 'Female',
                                        enabled: values.sport?.genders?.femaleOnly
                                      },
                                      { value: GENDER.MIXED, label: 'Mixed', enabled: values.sport?.genders?.mixed }
                                    ]
                                      .filter(option => option.enabled)
                                      .map(option => (
                                        <button
                                          type="button"
                                          key={option.value}
                                          className={values.gender === option.value ? 'is-selected' : ''}
                                          onClick={() => {
                                            setFieldValue('gender', option.value);
                                            setFieldValue(
                                              'isMixedTeamsAvailable',
                                              option.value === GENDER.MIXED ? YES_NO_OPTIONS.YES : YES_NO_OPTIONS.NO
                                            );
                                          }}
                                        >
                                          {option.label}
                                        </button>
                                      ))}
                                    {!values.sport ? (
                                      <span className="utCreateWizard__chipsHint">Select sport first</span>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className={isCreateWizard ? 'col-md-12 utCreateWizard__basicsAges' : 'col-md-6'}>
                                <div className="form-group">
                                  <div className="utCreateWizard__ageHead">
                                    <strong>
                                      Age groups <span className="utCreateWizard__required">*</span>
                                    </strong>
                                    {values.tournamentType === TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT ? (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          const all = this.getAgeGroup().map(option => Number(option.value));
                                          setFieldValue(
                                            'ageGroups',
                                            (values.ageGroups || []).length === all.length ? [] : all
                                          );
                                          setFieldTouched('ageGroups', true, false);
                                        }}
                                      >
                                        {(values.ageGroups || []).length === this.getAgeGroup().length
                                          ? 'Clear all'
                                          : 'Select all'}
                                      </button>
                                    ) : null}
                                  </div>
                                  <div
                                    className={`utCreateWizard__ageStages ${
                                      errors.ageGroups && (touched.ageGroups || submitCount > 0) ? 'is-invalid' : ''
                                    }`}
                                    aria-label="Ages"
                                  >
                                    {[
                                      {
                                        key: 'early',
                                        label: 'Early years',
                                        options: this.getAgeGroup().filter(option =>
                                          [0, 15, 16].includes(Number(option.value))
                                        )
                                      },
                                      {
                                        key: 'primary',
                                        label: 'Primary',
                                        options: this.getAgeGroup().filter(option =>
                                          [1, 2, 3, 4, 5, 6].includes(Number(option.value))
                                        )
                                      },
                                      {
                                        key: 'secondary',
                                        label: 'Secondary',
                                        options: this.getAgeGroup().filter(option =>
                                          [7, 8, 9, 10, 11].includes(Number(option.value))
                                        )
                                      },
                                      {
                                        key: 'sixth',
                                        label: 'Sixth form',
                                        options: this.getAgeGroup().filter(option =>
                                          [12, 13, 14].includes(Number(option.value))
                                        )
                                      }
                                    ].map(stage =>
                                      stage.options.length ? (
                                        <section key={stage.key}>
                                          <strong>{stage.label}</strong>
                                          <div className="utCreateWizard__chips">
                                            {stage.options.map(option => {
                                              const selected = (values.ageGroups || [])
                                                .map(Number)
                                                .includes(Number(option.value));
                                              return (
                                                <button
                                                  type="button"
                                                  key={option.value}
                                                  className={selected ? 'is-selected' : ''}
                                                  onClick={() => {
                                                    const current = (values.ageGroups || []).map(Number);
                                                    const next = selected
                                                      ? current.filter(age => age !== Number(option.value))
                                                      : values.tournamentType === TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT
                                                      ? [...current, Number(option.value)]
                                                      : [Number(option.value)];
                                                    setFieldValue('ageGroups', next);
                                                    setFieldTouched('ageGroups', true, false);
                                                  }}
                                                >
                                                  {option.text}
                                                </button>
                                              );
                                            })}
                                          </div>
                                        </section>
                                      ) : null
                                    )}
                                  </div>
                                  {(touched.ageGroups || submitCount > 0) && errors.ageGroups && (
                                    <div className="alert alert-danger">{String(errors.ageGroups)}</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </section>
                          <section
                            className={`utCreateWizard__section ${
                              isCreateWizard && this.state.wizardStep !== 1 ? 'is-hidden' : ''
                            }`}
                          >
                            {isCreateWizard ? (
                              <div className="utCreateWizard__sectionTitle">
                                <span>Step 2 of 8</span>
                                <h2>When and where?</h2>
                                <p>Set the tournament schedule, booking window and venue.</p>
                              </div>
                            ) : null}
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText={
                                      <>
                                        Start date/time <span className="utCreateWizard__required">*</span>
                                      </>
                                    }
                                    hintText=""
                                  />
                                  <Field name="startTime">
                                    {({ field }) => {
                                      let startTime: Date | null = null;
                                      if (values.startTime && moment(values.startTime).isValid()) {
                                        startTime = moment(values.startTime).toDate();
                                      }

                                      return (
                                        <SitDatePicker
                                          mode="datetime"
                                          value={startTime}
                                          onChange={(date: Date | null) => {
                                            if (!date) return;
                                            const nextStart = date;
                                            setFieldValue('startTime', nextStart);
                                            const currentEnd =
                                              values.endTime && moment(values.endTime).isValid()
                                                ? moment(values.endTime).toDate()
                                                : null;
                                            if (!currentEnd || currentEnd <= nextStart) {
                                              setFieldValue('endTime', addHours(nextStart, 6));
                                            }
                                          }}
                                          format="DD MMM YYYY, HH:mm"
                                          minuteStep={5}
                                          centered
                                          required
                                          clearable={false}
                                          className="utCreateWizard__dateTimePicker"
                                        />
                                      );
                                    }}
                                  </Field>
                                  {touched.startTime && errors.startTime && (
                                    <div className="alert alert-danger">{String(errors.startTime)}</div>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText={
                                      <>
                                        Finish date/time <span className="utCreateWizard__required">*</span>
                                      </>
                                    }
                                    hintText=""
                                  />
                                  <Field name="endTime">
                                    {({ field }) => {
                                      const start =
                                        values.startTime && moment(values.startTime).isValid()
                                          ? moment(values.startTime).toDate()
                                          : null;

                                      const end =
                                        values.endTime && moment(values.endTime).isValid()
                                          ? moment(values.endTime).toDate()
                                          : null;

                                      return (
                                        <SitDatePicker
                                          mode="datetime"
                                          value={end}
                                          onChange={(date: Date | null) => date && setFieldValue('endTime', date)}
                                          format="DD MMM YYYY, HH:mm"
                                          min={start || undefined}
                                          minuteStep={5}
                                          centered
                                          required
                                          clearable={false}
                                          className="utCreateWizard__dateTimePicker"
                                        />
                                      );
                                    }}
                                  </Field>
                                  {touched.endTime && errors.endTime && (
                                    <div className="alert alert-danger">{String(errors.endTime)}</div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Entries open"
                                    hintText={''}
                                  />
                                  <Field name="entriesOpen">
                                    {({ field }) => {
                                      const entriesOpen =
                                        values.entriesOpen && moment(values.entriesOpen).isValid()
                                          ? moment(values.entriesOpen).toDate()
                                          : null;

                                      const updateEntriesOpen = (next: Date | null) => {
                                        setFieldValue('entriesOpen', next);
                                        if (!next) return;
                                        const currentDeadline =
                                          values.deadlineForEntries && moment(values.deadlineForEntries).isValid()
                                            ? moment(values.deadlineForEntries).toDate()
                                            : null;
                                        if (!currentDeadline || currentDeadline <= next) {
                                          const tournamentStart =
                                            values.startTime && moment(values.startTime).isValid()
                                              ? moment(values.startTime).toDate()
                                              : null;
                                          setFieldValue(
                                            'deadlineForEntries',
                                            calcDefaultDeadlineForEntries(next, tournamentStart)
                                          );
                                        }
                                      };

                                      return (
                                        <SitDatePicker
                                          mode="datetime"
                                          value={entriesOpen}
                                          onChange={(date: Date | null) => updateEntriesOpen(date)}
                                          format="DD MMM YYYY, HH:mm"
                                          min={today}
                                          minuteStep={5}
                                          centered
                                          clearable
                                          className="utCreateWizard__dateTimePicker"
                                        />
                                      );
                                    }}
                                  </Field>
                                  {touched.entriesOpen && errors.entriesOpen && (
                                    <div className="alert alert-danger">{String(errors.entriesOpen)}</div>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Deadline for entries"
                                    hintText={''}
                                  />

                                  <Field name="deadlineForEntries">
                                    {({ field }) => {
                                      const entriesOpen =
                                        values.entriesOpen && moment(values.entriesOpen).isValid()
                                          ? moment(values.entriesOpen).toDate()
                                          : null;

                                      const deadline =
                                        values.deadlineForEntries && moment(values.deadlineForEntries).isValid()
                                          ? moment(values.deadlineForEntries).toDate()
                                          : null;

                                      const n = now();
                                      const minBase =
                                        entriesOpen && entriesOpen.getTime() > n.getTime() ? entriesOpen : n;

                                      return (
                                        <>
                                          <SitDatePicker
                                            mode="datetime"
                                            value={deadline}
                                            onChange={(date: Date | null) => {
                                              setFieldValue('deadlineForEntries', date);
                                              if (date) setFieldValue('isWhenSpacesAreFull', YES_NO_OPTIONS.NO);
                                            }}
                                            format="DD MMM YYYY, HH:mm"
                                            min={minBase}
                                            minuteStep={5}
                                            centered
                                            clearable
                                            className="utCreateWizard__dateTimePicker"
                                          />

                                          {/* Soft warning */}
                                          {showDeadlineAfterStartWarning && (
                                            <div
                                              className="alert alert-warning mt-2 mb-0"
                                              style={{ padding: '.5rem .75rem' }}
                                            >
                                              ⚠️ Booking deadline is after the tournament start time. This is allowed,
                                              but double-check it’s intended.
                                            </div>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>

                                  {touched.deadlineForEntries && errors.deadlineForEntries && (
                                    <div className="alert alert-danger">{String(errors.deadlineForEntries)}</div>
                                  )}
                                </div>
                                {!values.deadlineForEntries && (
                                  <div className="form-group">
                                    <LabelWithQuestionIcon
                                      customClass="bTournamentViewLabel"
                                      labelText="Or when spaces are full"
                                      hintText={''}
                                    />
                                    <Field component="select" name="isWhenSpacesAreFull" className="form-control">
                                      <option value={YES_NO_OPTIONS.NO}>{YES_NO_OPTIONS.NO}</option>
                                      <option value={YES_NO_OPTIONS.YES}>{YES_NO_OPTIONS.YES}</option>
                                    </Field>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="utCreateWizard__venueCard">
                              <header>
                                <div>
                                  <h3>
                                    Venue <span className="utCreateWizard__required">*</span>
                                  </h3>
                                  <p>Choose an existing venue by name or postcode, or create a new one.</p>
                                </div>
                                <button type="button" className="is-add" onClick={this.createVenueFormOpen}>
                                  <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M12 5v14M5 12h14" />
                                  </svg>
                                  Create venue
                                </button>
                              </header>
                              <Field name="venue">
                                {() => {
                                  const showVenueError =
                                    Boolean(errors.venue) && (Boolean(touched.venue) || submitCount > 0);

                                  return (
                                    <>
                                      <div
                                        className={`bVenueInput ${showVenueError ? 'bFieldInvalid' : ''}`}
                                        tabIndex={0}
                                        onBlur={() => setFieldTouched('venue', true, false)}
                                      >
                                        <Autocomplete
                                          placeholder="Start typing the postcode or venue name"
                                          searchFunction={text => getPostcodes(text, user)}
                                          getElementTitle={getNameByPlaceOrPostcode}
                                          customClass="mFullWidth utCreateWizard__venueSearch"
                                          defaultItem={this.state.venue}
                                          onSelect={venueItem => {
                                            let postcode = venueItem;
                                            if (isPlace(postcode)) {
                                              postcode = convertPlaceToPostcodeWithPlaceName(postcode);
                                            }
                                            setFieldValue('venue', postcode);
                                            setFieldTouched('venue', true, false);
                                            this.setState({ venue: postcode });
                                            this.getNewPoint(postcode.point);
                                          }}
                                        />
                                      </div>

                                      {showVenueError && (
                                        <div className="invalid-feedback d-block" role="alert">
                                          Venue is required
                                        </div>
                                      )}
                                    </>
                                  );
                                }}
                              </Field>
                            </div>
                          </section>
                          <section
                            className={`utCreateWizard__section ${
                              isCreateWizard && this.state.wizardStep !== 2 ? 'is-hidden' : ''
                            }`}
                          >
                            {isCreateWizard ? (
                              <div className="utCreateWizard__sectionTitle">
                                <span>Step 3 of 8</span>
                                <h2>Competition and contacts</h2>
                                <p>
                                  Define scoring, match result options and the people responsible for the tournament.
                                </p>
                              </div>
                            ) : null}
                            <div className="utCreateWizard__scoringSection">
                              <div className="utCreateWizard__scoringSectionHeader">
                                <span>Scoring</span>
                                <h3>
                                  {values.tournamentType === TOURNAMENT_TYPE.TEAM_TOURNAMENT
                                    ? 'Match points'
                                    : 'Individual and team points'}
                                </h3>
                                <p>
                                  {values.tournamentType === TOURNAMENT_TYPE.TEAM_TOURNAMENT
                                    ? 'Set the points awarded for each match outcome. Group tables and rankings use these values.'
                                    : 'Set the points awarded by finishing position and, where applicable, how many athletes count towards each school’s team score.'}
                                </p>
                              </div>
                              <div className="row">
                                <div
                                  className={
                                    values.tournamentType === TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT &&
                                    (values.tournamentSubType === TOURNAMENT_SUBTYPE.CROSS_COUNTRY ||
                                      values.tournamentSubType === TOURNAMENT_SUBTYPE.NATIONAL_CROSS_COUNTRY)
                                      ? 'col-md-6'
                                      : 'col-md-12'
                                  }
                                >
                                  <div className="form-group utCreateWizard__scoring">
                                    <LabelWithQuestionIcon
                                      customClass="bTournamentViewLabel"
                                      labelText={
                                        isTeamScoring ? 'Points by match outcome' : 'Points by finishing position'
                                      }
                                      hintText={
                                        isTeamScoring
                                          ? 'Set the points awarded for each possible match outcome.'
                                          : 'Enter points in finishing order, starting with first place.'
                                      }
                                    />
                                    {isTeamScoring ? (
                                      <>
                                        <div className="utCreateWizard__teamScoring">
                                          {teamScoringValues.map((score, index) => (
                                            <label key={teamScoringLabels[index]}>
                                              <span>{teamScoringLabels[index]}</span>
                                              <input
                                                type="text"
                                                inputMode="numeric"
                                                value={score}
                                                aria-label={`${teamScoringLabels[index]} points`}
                                                onChange={event => updateTeamScoring(index, event.target.value)}
                                                className={touched.scoring && errors.scoring ? 'is-invalid' : ''}
                                              />
                                            </label>
                                          ))}
                                        </div>
                                        <div className="utCreateWizard__scoringPreview">
                                          {isNetballScoring ? (
                                            <>
                                              A team gets <b>{teamScoringValues[0] || 0}</b> points for a win,{' '}
                                              <b>{teamScoringValues[1] || 0}</b> for a draw,{' '}
                                              <b>{teamScoringValues[2] || 0}</b> for a loss where it scores{' '}
                                              {values.halfScoreForNetball ? 'at least' : 'more than'} 50% of its
                                              opponent’s score, and <b>{teamScoringValues[3] || 0}</b> for any other
                                              loss.
                                            </>
                                          ) : (
                                            <>
                                              A team gets <b>{teamScoringValues[0] || 0}</b> points for a win,{' '}
                                              <b>{teamScoringValues[1] || 0}</b> for a draw where goals are scored,{' '}
                                              <b>{teamScoringValues[2] || 0}</b> for a 0–0 draw, and{' '}
                                              <b>{teamScoringValues[3] || 0}</b> for a loss.
                                            </>
                                          )}
                                        </div>
                                        {isNetballScoring ? (
                                          <Field name="halfScoreForNetball">
                                            {({ field, form }) => (
                                              <div className="utCreateWizard__settingRow utCreateWizard__netballRule">
                                                <span>
                                                  <b>Include exactly 50%</b>
                                                  <small>
                                                    When enabled, scoring exactly half of the opponent’s score qualifies
                                                    for {teamScoringValues[2] || 0}{' '}
                                                    {Number(teamScoringValues[2]) === 1 ? 'point' : 'points'}.
                                                  </small>
                                                </span>
                                                <Switch
                                                  {...field}
                                                  value={field.value}
                                                  onChange={() => form.setFieldValue(field.name, !field.value)}
                                                />
                                              </div>
                                            )}
                                          </Field>
                                        ) : null}
                                      </>
                                    ) : (
                                      <>
                                        <Field name="scoring">
                                          {({ field, form }) => (
                                            <input
                                              {...field}
                                              type="text"
                                              inputMode="numeric"
                                              className={`form-control ${
                                                touched.scoring && errors.scoring ? 'is-invalid' : ''
                                              }`}
                                              placeholder="e.g. 10, 8, 6, 5, 4, 3, 2, 1"
                                              onChange={event =>
                                                form.setFieldValue(
                                                  field.name,
                                                  event.target.value.replace(/[^\d,\s]/g, '')
                                                )
                                              }
                                            />
                                          )}
                                        </Field>
                                        <div className="utCreateWizard__scoringPreview">
                                          {scoringValues.length ? (
                                            <>
                                              {scoringValues.map((score, index) => (
                                                <span key={`${index}_${score}`}>
                                                  <b>{index + 1}</b>
                                                  {index === 0
                                                    ? 'st'
                                                    : index === 1
                                                    ? 'nd'
                                                    : index === 2
                                                    ? 'rd'
                                                    : 'th'}{' '}
                                                  place: {score} points
                                                </span>
                                              ))}
                                              <small>Places after {scoringValues.length} receive 0 points.</small>
                                            </>
                                          ) : (
                                            'Add one value for every place that should receive points.'
                                          )}
                                        </div>
                                      </>
                                    )}
                                    {touched.scoring && errors.scoring && (
                                      <div className="alert alert-danger">{errors.scoring}</div>
                                    )}
                                  </div>
                                </div>
                                {values.tournamentType === TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT &&
                                (values.tournamentSubType === TOURNAMENT_SUBTYPE.CROSS_COUNTRY ||
                                  values.tournamentSubType === TOURNAMENT_SUBTYPE.NATIONAL_CROSS_COUNTRY) ? (
                                  <div className="col-md-6">
                                    <div className="form-group utCreateWizard__teamScoreComposition">
                                      <LabelWithQuestionIcon
                                        customClass="bTournamentViewLabel"
                                        labelText="Athletes counting towards the team score"
                                        hintText="Choose how many of each school’s highest-placed athletes contribute to the team total for every age group and gender."
                                      />
                                      <p className="utCreateWizard__fieldHelp">
                                        The best placed athletes from each school are counted. Enter 0 if a category
                                        should not contribute.
                                      </p>
                                      <div className="utCreateWizard__teamScoreTable">
                                        <div className="utCreateWizard__teamScoreTableHead" aria-hidden="true">
                                          <span>Age group</span>
                                          <span>Girls</span>
                                          <span>Boys</span>
                                        </div>
                                        {values.ageGroups &&
                                          values.ageGroups.map(age => (
                                            <div className="utCreateWizard__teamScoreTableRow" key={`age_${age}`}>
                                              <strong>Y{age}</strong>
                                              <Field
                                                type="number"
                                                min="0"
                                                name={`positionsCountForTeamPoints.${age}_G`}
                                                className="form-control"
                                                aria-label={`Y${age} Girls athletes counting towards team score`}
                                              />
                                              <Field
                                                type="number"
                                                min="0"
                                                name={`positionsCountForTeamPoints.${age}_B`}
                                                className="form-control"
                                                aria-label={`Y${age} Boys athletes counting towards team score`}
                                              />
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div className="row">
                              {values.tournamentType === TOURNAMENT_TYPE.TEAM_TOURNAMENT ? (
                                <div className="col-12">
                                  <div className="form-group">
                                    <LabelWithQuestionIcon
                                      customClass="bTournamentViewLabel"
                                      labelText="Match result workflow"
                                      hintText="Publish immediately preserves the current behaviour. Review mode keeps changes private until an organiser publishes them."
                                    />
                                    <Field component="select" name="resultPublishingMode" className="form-control">
                                      <option value="IMMEDIATE">Publish immediately</option>
                                      <option value="REVIEW">Review before publishing</option>
                                    </Field>
                                  </div>
                                  <div className="utCreateWizard__settingRow">
                                    <span>
                                      <b>Match details</b>
                                      <small>Choose the additional result information available to organisers.</small>
                                    </span>
                                    <div className="d-flex flex-wrap" style={{ gap: 16 }}>
                                      <label>
                                        <Field type="checkbox" name="supportsHalfTime" /> Half-time score
                                      </label>
                                      <label>
                                        <Field type="checkbox" name="supportsExtraTime" /> Extra time
                                      </label>
                                      <label>
                                        <Field type="checkbox" name="supportsShootout" /> Penalties
                                      </label>
                                      <label>
                                        <Field type="checkbox" name="supportsScorers" /> Scorers
                                      </label>
                                    </div>
                                  </div>
                                  {values.supportsScorers ? (
                                    <div className="form-group mt-2">
                                      <label className="bTournamentViewLabel">Scorer time detail</label>
                                      <Field component="select" name="scorerTimePrecision" className="form-control">
                                        <option value="NONE">No time</option>
                                        <option value="MINUTE">Minutes</option>
                                        <option value="SECOND">Minutes and seconds</option>
                                      </Field>
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                              {values.tournamentType === TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT ? (
                                <>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <LabelWithQuestionIcon
                                        customClass="bTournamentViewLabel"
                                        labelText="Default event duration"
                                        hintText="Used to calculate the finish time when a new individual tournament event is created. You can still change the finish time on each event."
                                      />
                                      <div className="input-group">
                                        <Field
                                          type="number"
                                          min="1"
                                          max="1440"
                                          step="1"
                                          name="defaultEventDurationMinutes"
                                          className="form-control"
                                        />
                                        <div className="input-group-append">
                                          <span className="input-group-text">minutes</span>
                                        </div>
                                      </div>
                                      {touched.defaultEventDurationMinutes && errors.defaultEventDurationMinutes ? (
                                        <div className="alert alert-danger mt-2">
                                          {errors.defaultEventDurationMinutes}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                    <LabelWithQuestionIcon
                                      customClass="bTournamentViewLabel"
                                      labelText="Schools can submit results"
                                      hintText={
                                        'Enable this option to allow schools to submit their own competition results. This feature is particularly useful for remote or virtual competitions, facilitating efficient result collection without the need for physical presence. It can also streamline the process of selecting teams to represent your union at higher-level competitions.'
                                      }
                                    />
                                    <Field component="select" name="isSchoolCanSubmitResult" className="form-control">
                                      <option value={YES_NO_OPTIONS.NO}>{YES_NO_OPTIONS.NO}</option>
                                      <option value={YES_NO_OPTIONS.YES}>{YES_NO_OPTIONS.YES}</option>
                                    </Field>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>

                            <div className={`utCreateWizard__settingRow ${isCreateWizard ? 'is-hidden' : ''}`}>
                              <span>
                                <b>Show age groups on the public website</b>
                                <small>
                                  Visitors will see the eligible age group beside each tournament category and entry.
                                </small>
                              </span>
                              <Field name="isAgeGroupsOnWebSiteVisible">
                                {({ field, form }) => (
                                  <Switch
                                    {...field}
                                    value={field.value === YES_NO_OPTIONS.YES}
                                    onChange={() =>
                                      form.setFieldValue(
                                        field.name,
                                        field.value === YES_NO_OPTIONS.YES ? YES_NO_OPTIONS.NO : YES_NO_OPTIONS.YES
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </div>

                            <div className="utCreateWizard__compactField">
                              <div className="form-group">
                                <LabelWithQuestionIcon
                                  customClass="bTournamentViewLabel"
                                  labelText="Maximum players per team"
                                  hintText="This limits the squad size a school can submit for one team. Use 0 or leave empty for no limit."
                                />
                                <p className="utCreateWizard__fieldHelp">
                                  Sets the largest squad a school may submit for each team. It controls entry forms and
                                  prevents schools exceeding the permitted roster size. Enter 0 for unlimited.
                                </p>
                                <Field
                                  type="number"
                                  name="maxPlayersPerTeam"
                                  className={`form-control ${
                                    touched.maxPlayersPerTeam && errors.maxPlayersPerTeam ? 'is-invalid' : ''
                                  }`}
                                  placeholder="0 = unlimited"
                                />
                                {touched.maxPlayersPerTeam && errors.maxPlayersPerTeam && (
                                  <div className="alert alert-danger">{errors.maxPlayersPerTeam}</div>
                                )}
                              </div>
                            </div>

                            {values.tournamentType === TOURNAMENT_TYPE.INDIVIDUAL_TOURNAMENT ? (
                              <div className="utCreateWizard__participantLimits">
                                <div className="utCreateWizard__participantLimitsHeader">
                                  <div>
                                    <strong>Student participation limits</strong>
                                    <small>
                                      Control event entry limits across this tournament. Enter 0 for unlimited.
                                    </small>
                                  </div>
                                </div>
                                <div className="utCreateWizard__settingRow">
                                  <span>
                                    <b>Enforce participant limit in events</b>
                                    <small>
                                      Apply each sport’s maximum participants per team when students are allocated to
                                      events.
                                    </small>
                                  </span>
                                  <Field name="isEventParticipantLimitEnforced">
                                    {({ field, form }) => (
                                      <Switch
                                        {...field}
                                        value={field.value}
                                        onChange={() => form.setFieldValue(field.name, !field.value)}
                                      />
                                    )}
                                  </Field>
                                </div>
                                <div className="utCreateWizard__participantLimitGrid">
                                  <div className="form-group">
                                    <LabelWithQuestionIcon
                                      customClass="bTournamentViewLabel"
                                      labelText="Max individual events per student"
                                      hintText="The maximum number of individual events one student may enter in this tournament. Use 0 for unlimited."
                                    />
                                    <Field
                                      type="number"
                                      min="0"
                                      name="maxIndividualEventsPerStudent"
                                      className={`form-control ${
                                        touched.maxIndividualEventsPerStudent && errors.maxIndividualEventsPerStudent
                                          ? 'is-invalid'
                                          : ''
                                      }`}
                                      placeholder="0 = unlimited"
                                    />
                                    {touched.maxIndividualEventsPerStudent && errors.maxIndividualEventsPerStudent ? (
                                      <div className="alert alert-danger">{errors.maxIndividualEventsPerStudent}</div>
                                    ) : null}
                                  </div>
                                  <div className="form-group">
                                    <LabelWithQuestionIcon
                                      customClass="bTournamentViewLabel"
                                      labelText="Max relay events per student"
                                      hintText="The maximum number of relay or team events one student may enter in this tournament. Use 0 for unlimited."
                                    />
                                    <Field
                                      type="number"
                                      min="0"
                                      name="maxRelayEventsPerStudent"
                                      className={`form-control ${
                                        touched.maxRelayEventsPerStudent && errors.maxRelayEventsPerStudent
                                          ? 'is-invalid'
                                          : ''
                                      }`}
                                      placeholder="0 = unlimited"
                                    />
                                    {touched.maxRelayEventsPerStudent && errors.maxRelayEventsPerStudent ? (
                                      <div className="alert alert-danger">{errors.maxRelayEventsPerStudent}</div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className="form-group utCreateWizard__adminsBlock">
                              <LabelWithQuestionIcon
                                customClass="bTournamentViewLabel"
                                labelText="Organisers"
                                hintText={''}
                              />
                              <Field
                                component="textarea"
                                rows="3"
                                name="organisers"
                                className={`${
                                  touched.organisers && errors.organisers ? 'form-control is-invalid' : 'form-control '
                                }`}
                                placeholder="Add organisers’ details "
                              />
                              {touched.organisers && errors.organisers ? (
                                <div className="alert alert-danger">{errors.organisers}</div>
                              ) : null}
                            </div>

                            <div className="form-group">
                              <LabelWithQuestionIcon
                                customClass="bTournamentViewLabel"
                                labelText="Organisers email"
                                hintText={
                                  "Enter the organiser's email address to enable schools to contact them directly for any inquiries or issues. Additionally, this email address will be set as the 'reply-to' address for all notifications sent regarding this tournament, streamlining communication."
                                }
                              />
                              <Field
                                type="email"
                                name="organisersEmail"
                                className={`${
                                  touched.organisersEmail && errors.organisersEmail
                                    ? 'form-control is-invalid'
                                    : 'form-control '
                                }`}
                                placeholder="Enter organisers email"
                              />
                              {touched.organisersEmail && errors.organisersEmail ? (
                                <div className="alert alert-danger">{errors.organisersEmail}</div>
                              ) : null}
                            </div>

                            <div className="form-group">
                              <LabelWithQuestionIcon
                                customClass="bTournamentViewLabel"
                                labelText="Tournament admins"
                                hintText="Select union admins responsible for this tournament."
                              />

                              {Array.isArray(values.admins) && values.admins.length > 0 && (
                                <div className="d-flex flex-wrap mb-2">
                                  {values.admins.map((a, idx) => (
                                    <div key={`${a.userId}_${idx}`} className="d-flex">
                                      <div className="eSelectedItem">
                                        <span>{a.name || a.userId}</span>
                                        <div className="ml-1">
                                          <div
                                            className="eButtonClose"
                                            onClick={() => {
                                              const next = values.admins.filter((_, i) => i !== idx);
                                              setFieldValue('admins', next);
                                              this.setState({ adminsTouched: true });
                                            }}
                                          >
                                            <span>&times;</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}

                              <div className="utCreateWizard__adminPickerRow">
                                <Field name="adminsAdder">
                                  {() => (
                                    <Autocomplete
                                      key={(values.admins || []).map(a => a.userId).join('|')}
                                      placeholder="Search by name or email"
                                      searchFunction={(text: string) =>
                                        this.getAdminsSearchFunction(text, values.admins || [])
                                      }
                                      getElementTitle={this.getFullNameWithEmail}
                                      customClass="mFullWidth"
                                      onSelect={(u: any) => {
                                        if (!u || !(u.id || u._id)) return;
                                        const id = u.id || u._id;
                                        if ((values.admins || []).some(x => x.userId === id)) return;
                                        const name = [u.firstName, u.lastName].filter(Boolean).join(' ') || u.name;
                                        setFieldValue('admins', [
                                          ...(values.admins || []),
                                          { userId: id, permissionId: u.permissionId, name }
                                        ]);
                                        this.setState({ adminsTouched: true });
                                      }}
                                    />
                                  )}
                                </Field>
                                {(values.admins || []).length > 0 ? (
                                  <button
                                    type="button"
                                    className="utCreateWizard__clearAdmins"
                                    onClick={() => {
                                      setFieldValue('admins', []);
                                      this.setState({ adminsTouched: true });
                                    }}
                                  >
                                    Clear admins
                                  </button>
                                ) : null}
                              </div>
                            </div>

                            <div className="utCreateWizard__settingRow mt-3">
                              <span>
                                <b>Use admins list for notifications</b>
                                <small>
                                  Notifications go only to the selected tournament admins. When off, all union admins
                                  receive them.
                                </small>
                              </span>
                              <div>
                                <Field name="useAdminsForNotifications">
                                  {({ field, form }) => {
                                    const isAdminsEmpty = !(values.admins && values.admins.length > 0);
                                    if (isAdminsEmpty && field.value === true) {
                                      form.setFieldValue(field.name, false, false);
                                    }
                                    return (
                                      <Switch
                                        {...field}
                                        value={field.value}
                                        onChange={() => form.setFieldValue(field.name, !field.value)}
                                        disabled={isAdminsEmpty}
                                      />
                                    );
                                  }}
                                </Field>
                              </div>
                            </div>
                            {(!values.admins || values.admins.length === 0) && (
                              <div className="text-muted mt-1" style={{ fontSize: '.875rem' }}>
                                Select at least one tournament admin to enable this switch.
                              </div>
                            )}
                          </section>
                        </div>
                      </div>

                      <div className={`col-md-6 ${isCreateWizard && this.state.wizardStep < 3 ? 'is-hidden' : ''}`}>
                        <div className="bTournamentFormBlock rounded">
                          <section
                            className={`utCreateWizard__section ${
                              !isCreateWizard || this.state.wizardStep !== 3 ? 'is-hidden' : ''
                            }`}
                          >
                            <div className="utCreateWizard__sectionTitle">
                              <span>Step 4 of 8</span>
                              <h2>Appearance</h2>
                              <p>Prepare the public-facing tournament card and banner.</p>
                            </div>
                            <div className="form-group">
                              <LabelWithQuestionIcon
                                customClass="bTournamentViewLabel"
                                labelText="Tournament cover"
                                hintText="Shown as the 3:1 hero banner on the public tournament website."
                              />
                              <TournamentCoverUploader
                                user={user}
                                values={coverPhotoUrls}
                                onChange={nextUrls =>
                                  this.setState({ coverPhotoUrls: nextUrls, isImageError: false, auxiliaryDirty: true })
                                }
                                onError={() => this.setState({ isImageError: true })}
                              />
                            </div>
                            <div className="utCreateWizard__settingRow">
                              <span>
                                <b>Show age groups on the public website</b>
                                <small>Visitors will see eligible ages beside tournament categories and entries.</small>
                              </span>
                              <Field name="isAgeGroupsOnWebSiteVisible">
                                {({ field, form }) => (
                                  <Switch
                                    {...field}
                                    value={field.value === YES_NO_OPTIONS.YES}
                                    onChange={() =>
                                      form.setFieldValue(
                                        field.name,
                                        field.value === YES_NO_OPTIONS.YES ? YES_NO_OPTIONS.NO : YES_NO_OPTIONS.YES
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </div>
                            <div className="form-group">
                              <LabelWithQuestionIcon
                                customClass="bTournamentViewLabel"
                                labelText="Tournament tags"
                                hintText="Tags help union admins filter and organise tournaments."
                              />
                              <div className="utCreateWizard__tagPicker">
                                {this.state.tournamentTagOptions.length ? (
                                  this.state.tournamentTagOptions.map(tag => {
                                    const selected = this.state.selectedTournamentTagIds.includes(String(tag.id));
                                    return (
                                      <button
                                        key={tag.id}
                                        type="button"
                                        className={selected ? 'is-selected' : ''}
                                        style={{ '--tag-colour': tag.tagColor || '#227ebd' } as React.CSSProperties}
                                        onClick={() =>
                                          this.setState(state => ({
                                            selectedTournamentTagIds: selected
                                              ? state.selectedTournamentTagIds.filter(id => id !== String(tag.id))
                                              : [...state.selectedTournamentTagIds, String(tag.id)],
                                            auxiliaryDirty: true
                                          }))
                                        }
                                      >
                                        {tag.tagName}
                                        {tag.isPublic ? <em>Public</em> : null}
                                      </button>
                                    );
                                  })
                                ) : (
                                  <small>No tournament tags have been created for this union.</small>
                                )}
                              </div>
                              <button
                                type="button"
                                className="utCreateWizard__createTag"
                                onClick={() => this.setState({ isTagModalOpen: true })}
                              >
                                + Create new tag
                              </button>
                            </div>
                          </section>
                          <section
                            className={`utCreateWizard__section ${
                              isCreateWizard && this.state.wizardStep !== 7 ? 'is-hidden' : ''
                            }`}
                          >
                            {isCreateWizard ? (
                              <>
                                <div className="utCreateWizard__sectionTitle">
                                  <span>Step 8 of 8</span>
                                  <h2>Review and optional settings</h2>
                                  <p>Add payment or advanced configuration, then create the tournament.</p>
                                </div>
                                <div className="utCreateWizard__review">
                                  <div>
                                    <small>Tournament</small>
                                    <strong>{values.name || 'Not provided'}</strong>
                                    <span>{values.sport?.name || values.sport?.text || 'Sport not selected'}</span>
                                  </div>
                                  <div>
                                    <small>Format</small>
                                    <strong>
                                      {TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING[values.tournamentType] ||
                                        values.tournamentType}
                                    </strong>
                                    <span>
                                      {TOURNAMENT_SUBTYPE_SERVER_TO_CLIENT_MAPPING[values.tournamentSubType] ||
                                        values.tournamentSubType}
                                    </span>
                                  </div>
                                  <div>
                                    <small>Schedule</small>
                                    <strong>
                                      {values.startTime && moment(values.startTime).isValid()
                                        ? moment(values.startTime).format('DD MMM YYYY, HH:mm')
                                        : 'Not provided'}
                                    </strong>
                                    <span>
                                      to{' '}
                                      {values.endTime && moment(values.endTime).isValid()
                                        ? moment(values.endTime).format('DD MMM YYYY, HH:mm')
                                        : 'not provided'}
                                    </span>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            <div className="utCreateWizard__settingRow">
                              <span>
                                <b>Paid tournament</b>
                                <small>
                                  Enable this when schools must pay to enter. You can then choose the price and
                                  receiving account.
                                </small>
                              </span>
                              <Field name="isPaymentSettingsVisible">
                                {({ field, form }) => (
                                  <Switch
                                    {...field}
                                    value={field.value}
                                    onChange={() => form.setFieldValue(field.name, !field.value)}
                                  />
                                )}
                              </Field>
                            </div>

                            {values.isPaymentSettingsVisible && (
                              <div className="utCreateWizard__optionalSettings">
                                <LabelWithQuestionIcon
                                  customClass="bTournamentViewLabel"
                                  labelText={
                                    isPaymentsEnabled
                                      ? 'Price type'
                                      : 'Price type (paid price type available for school union with payment enabled options)'
                                  }
                                  hintText=""
                                />
                                <Field
                                  disabled={isTournamentExists}
                                  component="select"
                                  name="priceType"
                                  className="form-control mb-3"
                                  onChange={event => {
                                    const priceType = event.target.value;
                                    setFieldValue('priceType', priceType);
                                    if (priceType === TOURNAMENT_PRICE_TYPE.FREE) {
                                      setFieldValue('price', 0);
                                    }
                                  }}
                                >
                                  <option value={TYPE_OF_TOURNAMENT_PRICE_TYPE_OPTIONS[0].value}>
                                    {TYPE_OF_TOURNAMENT_PRICE_TYPE_OPTIONS[0].text}
                                  </option>
                                  {isPaymentsEnabled && (
                                    <option value={TYPE_OF_TOURNAMENT_PRICE_TYPE_OPTIONS[1].value}>
                                      {TYPE_OF_TOURNAMENT_PRICE_TYPE_OPTIONS[1].text}
                                    </option>
                                  )}
                                </Field>
                                <LabelWithQuestionIcon
                                  customClass="bTournamentViewLabel"
                                  labelText="Payment type (only for paid price type)"
                                  hintText={''}
                                />
                                <Field
                                  disabled={values.priceType === TOURNAMENT_PRICE_TYPE.FREE}
                                  component="select"
                                  name="paymentType"
                                  className="form-control mb-3"
                                >
                                  <option value={TYPE_OF_TOURNAMENT_PAYMENT_TYPE_OPTIONS[0].value}>
                                    {TYPE_OF_TOURNAMENT_PAYMENT_TYPE_OPTIONS[0].text}
                                  </option>
                                </Field>
                                <LabelWithQuestionIcon
                                  customClass="bTournamentViewLabel"
                                  labelText="Price"
                                  hintText={''}
                                />
                                <Field
                                  disabled={values.priceType === TOURNAMENT_PRICE_TYPE.FREE}
                                  type="text"
                                  name="price"
                                >
                                  {({ field }) => {
                                    return (
                                      <CurrencyInput
                                        currency={CLUB_CURRENCY.POUND as CURRENCY_TYPE}
                                        onChange={value => {
                                          setFieldValue('price', Number(value));
                                        }}
                                        value={field.value}
                                        disabled={values.priceType === TOURNAMENT_PRICE_TYPE.FREE}
                                      />
                                    );
                                  }}
                                </Field>
                                {touched.price && errors.price ? (
                                  <div className="alert alert-danger">{errors.price}</div>
                                ) : null}
                                <LabelWithQuestionIcon
                                  customClass="bTournamentViewLabel"
                                  labelText="Payment Accounts (only for paid price type)"
                                  hintText={''}
                                />
                                <Field name="paymentAccountCurrent">
                                  {({ field }) => {
                                    return (
                                      <Autocomplete
                                        searchFunction={this.getPaymentAccounts}
                                        getElementTitle={getName}
                                        customClass="mFullWidth mb-3"
                                        defaultItem={values.paymentAccountCurrent}
                                        onSelect={paymentAccountCurrent => {
                                          setFieldValue('paymentAccountId', paymentAccountCurrent.id);
                                        }}
                                        disabled={values.priceType === TOURNAMENT_PRICE_TYPE.FREE}
                                      />
                                    );
                                  }}
                                </Field>
                              </div>
                            )}

                            <div className="utCreateWizard__settingRow">
                              <span>
                                <b>Advanced settings</b>
                                <small>
                                  Configure streaming and the column mapping used when importing event results.
                                </small>
                              </span>
                              <Field name="isAdvancedSettingsVisible">
                                {({ field, form }) => (
                                  <Switch
                                    {...field}
                                    value={field.value}
                                    onChange={() => form.setFieldValue(field.name, !field.value)}
                                  />
                                )}
                              </Field>
                            </div>

                            {values.isAdvancedSettingsVisible && (
                              <div className="utCreateWizard__optionalSettings">
                                <LabelWithQuestionIcon
                                  customClass="bTournamentViewLabel"
                                  labelText="Tournament Stream"
                                  hintText={''}
                                />
                                <Field
                                  component="select"
                                  name="tournamentStreamIsEnabled"
                                  className="form-control mb-3"
                                >
                                  <option value={YES_NO_OPTIONS.NO}>{YES_NO_OPTIONS.NO}</option>
                                  <option value={YES_NO_OPTIONS.YES}>{YES_NO_OPTIONS.YES}</option>
                                </Field>
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Stream ID http://youtube.com/"
                                    hintText={''}
                                  />
                                  <Field type="text" name="tournamentStreamUrl" className="form-control" />
                                </div>
                                <label>Event import properties</label>
                                <div className="form-group">
                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Player number:"
                                    hintText={''}
                                  />
                                  <Field
                                    type="text"
                                    name="resultImportPropertiesFieldsPlayerNumber"
                                    className="form-control mb-3"
                                  />
                                  {touched.resultImportPropertiesFieldsPlayerNumber &&
                                  errors.resultImportPropertiesFieldsPlayerNumber ? (
                                    <div className="alert alert-danger">
                                      {errors.resultImportPropertiesFieldsPlayerNumber}
                                    </div>
                                  ) : null}

                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Team code:"
                                    hintText={''}
                                  />
                                  <Field
                                    type="text"
                                    name="resultImportPropertiesFieldsTeamCode"
                                    className="form-control mb-3"
                                  />
                                  {touched.resultImportPropertiesFieldsTeamCode &&
                                  errors.resultImportPropertiesFieldsTeamCode ? (
                                    <div className="alert alert-danger">
                                      {errors.resultImportPropertiesFieldsTeamCode}
                                    </div>
                                  ) : null}

                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Result:"
                                    hintText={''}
                                  />
                                  <Field
                                    type="text"
                                    name="resultImportPropertiesFieldsResult"
                                    className="form-control mb-3"
                                  />
                                  {touched.resultImportPropertiesFieldsResult &&
                                  errors.resultImportPropertiesFieldsResult ? (
                                    <div className="alert alert-danger">
                                      {errors.resultImportPropertiesFieldsResult}
                                    </div>
                                  ) : null}

                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Delimiter:"
                                    hintText={''}
                                  />
                                  <Field
                                    type="text"
                                    name="resultImportPropertiesFieldsDelimiter"
                                    className="form-control mb-3"
                                  />
                                  {touched.resultImportPropertiesFieldsDelimiter &&
                                  errors.resultImportPropertiesFieldsDelimiter ? (
                                    <div className="alert alert-danger">
                                      {errors.resultImportPropertiesFieldsDelimiter}
                                    </div>
                                  ) : null}

                                  <LabelWithQuestionIcon
                                    customClass="bTournamentViewLabel"
                                    labelText="Result mask:"
                                    hintText={''}
                                  />
                                  <Field
                                    type="text"
                                    name="resultImportPropertiesResultMask"
                                    className="form-control mb-3"
                                    title={hintTextResultMask}
                                  />
                                  {touched.resultImportPropertiesResultMask &&
                                  errors.resultImportPropertiesResultMask ? (
                                    <div className="alert alert-danger">{errors.resultImportPropertiesResultMask}</div>
                                  ) : null}
                                </div>
                              </div>
                            )}
                          </section>

                          <section
                            className={`utCreateWizard__section ${
                              isCreateWizard && this.state.wizardStep !== 4 ? 'is-hidden' : ''
                            }`}
                          >
                            <div className="utCreateWizard__sectionTitle">
                              <span>Step 5 of 8</span>
                              <h2>Custom sections</h2>
                              <p>Add optional content blocks to the public tournament page.</p>
                            </div>
                            {this.renderFormFieldListAnnouncements()}
                            <button
                              type="button"
                              className="utCreateWizard__addOptional"
                              onClick={this.onClickAddCustomSectionForm}
                            >
                              + Add custom section
                            </button>
                          </section>
                          <section
                            className={`utCreateWizard__section ${
                              isCreateWizard && this.state.wizardStep !== 5 ? 'is-hidden' : ''
                            }`}
                          >
                            <div className="utCreateWizard__sectionTitle">
                              <span>Step 6 of 8</span>
                              <h2>National Governing Bodies</h2>
                              <p>Add optional governing bodies or partner organisations.</p>
                            </div>
                            {this.renderFormFieldListGoverningBodies()}
                            <button
                              type="button"
                              className="utCreateWizard__addOptional"
                              onClick={this.onClickAddGoverningBodiesForm}
                            >
                              + Add governing body
                            </button>
                          </section>
                          <section
                            className={`utCreateWizard__section ${
                              isCreateWizard && this.state.wizardStep !== 6 ? 'is-hidden' : ''
                            }`}
                          >
                            <div className="utCreateWizard__sectionTitle">
                              <span>Step 7 of 8</span>
                              <h2>Sponsors</h2>
                              <p>Add sponsors shown in a separate section on the public tournament page.</p>
                            </div>
                            {this.renderFormFieldListSponsors()}
                            <button
                              type="button"
                              className="utCreateWizard__addOptional"
                              onClick={this.onClickAddSponsorForm}
                            >
                              + Add sponsor
                            </button>
                          </section>
                        </div>
                      </div>
                    </div>
                    {isCreateWizard ? (
                      <footer className="utCreateWizard__footer">
                        <div className="utCreateWizard__footerContext">
                          <span>
                            Step {this.state.wizardStep + 1} of {wizardSteps.length}
                          </span>
                          <strong>{wizardSteps[this.state.wizardStep].title}</strong>
                        </div>
                        <div>
                          <button type="button" className="is-cancel" onClick={requestCancel}>
                            Cancel
                          </button>
                          {this.state.wizardStep > 0 ? (
                            <button
                              type="button"
                              className="is-back"
                              onClick={() =>
                                this.setState(state => ({ wizardStep: Math.max(0, state.wizardStep - 1) }))
                              }
                            >
                              <span aria-hidden="true">←</span> Back
                            </button>
                          ) : null}
                          {this.state.wizardStep < wizardSteps.length - 1 ? (
                            <button type="button" className="is-primary" onClick={goToNextWizardStep}>
                              Continue <span aria-hidden="true">→</span>
                            </button>
                          ) : (
                            <button type="button" className="is-primary" onClick={submitWizard}>
                              {mode === MODE_TYPE.EDIT ? 'Save changes' : 'Create tournament'}
                            </button>
                          )}
                        </div>
                      </footer>
                    ) : (
                      <div className="bTournamentFormSectionButton">
                        <button type="button" className="btn btn-secondary mr-3" onClick={requestCancel}>
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-primary">
                          {positiveButtonTitle}
                        </button>
                      </div>
                    )}
                  </main>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}
